import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  NgbActiveModal,
  NgbCalendar,
  NgbDate,
  NgbDateStruct,
  NgbModal,
  NgbModalRef,
  NgbTimeStruct,
} from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FormBuilder,
  Validators,
  FormControl,
  FormGroup,
  FormArray,
} from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { environment } from '../../../../environments/environment';
import Swal from 'sweetalert2';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { NgxSpinnerService } from 'ngx-spinner';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import {
  MEMBER_SHOP_CATEGORIES,
  REGION_CATEGORY_IMAGE_LIST,
} from '../../../customers/marketplace/marketplace.model';
import { MemberTemplate } from '../../../admin/admin-market/product-template/product-template.component';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import $ from 'jquery';
import { FixMeLater, QRCodeElementType } from 'angularx-qrcode';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { CommunityProduct } from 'src/app/shareModule/models/community-product.model';
import { select, Store } from '@ngrx/store';
import {
  loadAllCommunityProducts
} from 'src/app/shareModule/states/community-product';
import { HttpEventType } from '@angular/common/http';
import copy from 'copy-to-clipboard';
import { selectUser } from 'src/app/shareModule/states/user-details';
import { User } from 'src/app/shareModule/models/user.model';
import { loadIndividualProducts } from 'src/app/shareModule/states/individual-all-product';
import { AppState } from 'src/app/shareModule/states/app.state';
import { loadFilteredCommunityProducts } from 'src/app/shareModule/states/filtered-community-product';
import { GoogleAnalyticsService } from 'src/app/shareModule/services/google-analytics.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { selectAllBizCategory } from 'src/app/shareModule/states/biz-category/biz-category.selector';
import { PopUpService } from 'src/app/popupservice.service';

declare const google: any;
@Component({
  selector: 'app-add-shop',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss'],
})
export class AddProductComponent implements OnInit, OnDestroy {
  menuSliderLeft: boolean = false;
  editNameShop: boolean = false;
  editDescShop: boolean = false;
  model: NgbDateStruct;
  today = new Date();
  minDate: NgbDateStruct = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate(),
  };
  selectedDates: NgbDateStruct[] = [];
  time: NgbTimeStruct = {
    hour: 10,
    minute: 0,
    second: 0,
  };
  meridian = true;
  date: { year: number; month: number };
  formattedDateTime: string;
  carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: 'auto',
  };
  // **** Inputs ****
  @Input() enableMemberShop: boolean = false;
  @Input() enableMemberShopAdmin: boolean = false;
  @Input() enableTemplateView: boolean = false;
  @Input() customTitle: string = '';
  @Input() isSingleProduct: boolean = false;
  // **** outputs Events ****
  @Output() shopUpdate = new EventEmitter<string>();
  @Output() templateViewEvents = new EventEmitter<{
    action: string;
    data: MemberTemplate;
  }>();

  // **** Child ****
  @ViewChild('shop_info_modal') shop_info_modal: ElementRef;
  @ViewChild('catmodal') addCategoryModal: ElementRef;
  @ViewChild('editcatmodal') editCategoryModal: ElementRef;
  @ViewChild('subcatmodal') addSubCategoryModal: ElementRef;
  @ViewChild('editsubcatmodal') editSubCategoryModal: ElementRef;
  @ViewChild('editProduct') editProduct: ElementRef;

  public refererId = null;
  // Variables
  public memberShopProductType: string = '';
  public memberShopCategories: Array<any> = MEMBER_SHOP_CATEGORIES;
  public memberShopSubcategories: Array<any> =
    this.commonService.subCategoryList;
  public isRecommendedProduct: boolean = false;
  public elementType: QRCodeElementType = 'url';

  public modalRef: any;
  public food_image_1_url: any = '';
  public food_image_2_url: any = '';
  public food_image_3_url: any = '';
  public food_image_4_url: any = '';
  public shoutImage: any = '';
  public shoutImageText: any = '';
  public indexImageUrl: any = '';
  public enableLoader: boolean = false;
  public editprodForm: FormGroup;
  public errorList: Array<string> = [];
  public isAd = false;
  public isAdmin = false;

  public isTypeShopProduct = false;
 public variantCategoryId = null
  private destroy$ = new Subject<void>()


  selectHoliday: boolean = false;
  categoryName: any;
  subcategoryName: any;
  selectedIndex = 0;
  categories = [];
  subcategories = [];
  
  public get selectedCatId(){
    return this._selectedCatId;
  }
  public set selectedCatId(value){
    this._selectedCatId = value;
    this._fetchTypesOf(value)
  }
  _selectedCatId: any = '';
  public selectedsubCatId: any = '';
  public selectedSubRegionId: any = '';
  form: FormGroup;
  prodForm: FormGroup;

  bannerForm: FormGroup;
  bottomImagesForm: FormGroup;
  bottomImagesFormEdit: FormGroup;
  submitted: boolean = false;
  logoPath: any;
  Shop_Banner_Path: any;
  qrPath: any;
  imgResultAfterCompress: any;

  iconPath1: any;
  selectedIcon1: File;
  iconPath2: any;
  selectedIcon2: File;
  iconPath3: any;
  selectedIcon3: File;
  iconPath4: any;
  selectedIcon4: File;
  jsonStrings: string;
  food_listing_response: any;
  imgUrl = environment.ImageUrl;
  food_details: any;

  edit_product_id: any;
  detailsIcon?: File = null;
  detailsIconConvertedUrl: string = ''

  get_selected_products_listing: any;
  selectedSubCatIndex: any = 0;
  foodSpecsArrayData: any[];
  get_all_product_banner_response: any;
  get_all_product_banner_length: any = 0;
  banner_image_url: any;
  banner_image_url_show: number;
  bannerPath: any;
  selectedBanner: File;
  foodSpecsLength: any;
  checkArray = [];
  showHideMemberPriceStatus: any;
  // ingredientsEdit: FormArray
  searchText: string = '';
  filteredProducts: any;
  bottom_banner_image_url: any;
  bottom_banner_image_url_show: number;
  bannerPathBottom: any;
  selectedBannerBottom: File;
  get_bottom_banner_response: any;
  get_one_bottom_banner_response: any;
  edit_bottom_banner_id: any;
  bottom_banner_image: any;
  bottom_edit_img_hide_show: boolean = false;
  adminId: any = 0;
  shopWebLink: string = '';
  logo_image_show: number;
  shop_Banner_image_show: boolean;
  logo_image_url: any;
  shop_Banner_image_url: any;
  selectedLogo: File;
  selectedShopBanner: File;
  qr_image_show: number;
  qr_image_url: any;
  selectedQr: File;
  public website: string = '';
  public address: string = '';
  public telegram: string = '';
  public bizCategory: string = '';
  qr_text: string = '';
  shop_logo: any = '';
  shop_banner: any = '';
  shop_qr_image: any = '';
  qr_text_value: any = '';
  productReview: any = {
    userName: '',
    comment: '',
    rating: 0,
  };
  imgBase64: any = '';
  addReviewModal: any = null;
  percent_value = 0;
  percent_type = 0;

  QrCodeValue = '';
  shopName: string = '';
  buyerContact: boolean = false;
  public postalCode: string = '';
  public postalCodeRegionName: string = '';
  shopTemplate: string;
  store_link: string = '';
  w_phone_number: string = '';
  shop_description: string = '';
  unit: string = '';
  shopId: string = '';
  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };
  ckEditorText: string = '';
  isTabDetailActive = 1;
  isTabDescriptionActive = 1;
  formType = 'Create';
  moreProductsSelect: any = [];
  moreProductsValue = 0;
  icons: any = [
    { dropdown: ['Popular', 'Top 10'], value: '', text: '', showText: false },
    { dropdown: ['Save Up Program'], value: '', text: '', showText: true },
    {
      dropdown: ['South', 'North East', 'West', 'North', 'East'],
      value: '',
      text: '',
      showText: true,
    },
  ];
  focusIcon: any = {};
  maps: any = {
    postalCode: '',
    latLong: {},
  };

  private moreServiceImages = new Map();
  private employeeImages = new Map();
  private variansImages = new Map();

  public encodedMorePromoBuffer: ArrayBuffer[] | string[] = [];
  public encodedEmployeeBuffer: ArrayBuffer[] | string[] = []
  public encodedVariantBuffer: ArrayBuffer[] | string[] = [];

  public deleteMoreServiceImg(i) {
    this.encodedMorePromoBuffer[i] = null;
    this.editprodForm.get('moreService').value[i].imageFile = '';

    const imageAttachName = 'imgMoreService' + i;
    this.moreServiceImages.delete(imageAttachName)
  }

  public clickButton(id){
    this.commonService.clickButton(id)
  }
  public async setShopIcon(event){
     [this.detailsIconConvertedUrl, this.detailsIcon] = await this.commonService.convertImageToURL(event)
  }
  public selectVariantImage(i) {
    document.getElementById('imgVariant' + i).click()
  }
  public selectMoreImage(i) {
    document.getElementById('img' + i).click()
  }
  public selectEmployeeImage(i) {
    document.getElementById('imgEmp' + i).click()
  }

  public deleteVariantImage(i) {
    this.encodedVariantBuffer[i] = null;
    this.editprodForm.get('ingredientsEdit').value[i].image = '';

    const imageAttachName = 'imgVairant' + i;
    this.employeeImages.delete(imageAttachName)

  }

  public deleteEmployeeServiceImg(i) {
    this.encodedEmployeeBuffer[i] = null;
    this.editprodForm.get('bizCompanyEmployees').value[i].imageFile = '';

    const imageAttachName = 'imgbizCompanyEmployees' + i;
    this.employeeImages.delete(imageAttachName)
  }

  public setImageOfVariant(event, i) {
    if (!event.target.files || !event.target.files.length) {
      this.editprodForm.get('ingredientsEdit').value[i].imageAttachName = '';
    }
    const file = event.target.files[0];
    const imageAttachName = 'imgVariant' + i;
    console.log('setting ', imageAttachName)
    this.editprodForm.get('ingredientsEdit').value[i].imageAttachName = imageAttachName;
    console.log('setting ', imageAttachName)
    this.variansImages.set(imageAttachName, file)


    const reader = new FileReader();
    reader.onload = () => {
      this.encodedVariantBuffer[i] = reader.result;
    }
    reader.readAsDataURL(file);

  }
  public setImageOfEmployee(event, i) {
    if (!event.target.files || !event.target.files.length) {
      this.editprodForm.get('bizCompanyEmployees').value[i].imageAttachName = '';
    }
    const file = event.target.files[0];
    const imageAttachName = 'imgbizCompanyEmployees' + i;
    console.log('setting ', imageAttachName)
    this.editprodForm.get('bizCompanyEmployees').value[i].imageAttachName = imageAttachName;
    console.log('setting ', imageAttachName)
    this.employeeImages.set(imageAttachName, file)


    const reader = new FileReader();
    reader.onload = () => {
      this.encodedEmployeeBuffer[i] = reader.result;
    }
    reader.readAsDataURL(file);

  }
  removeEmployeee(i) {
    const initValue = this.editprodForm.get('bizCompanyEmployees').value ?? []
    initValue.splice(i, 1)
    this.editprodForm.patchValue({
      bizCompanyEmployees: initValue
    })
    this.encodedMorePromoBuffer.splice(i, 1)
  }

  addEmployee() {
    const initValue = this.editprodForm.get('bizCompanyEmployees').value ?? []
    if (initValue.length >= 4) {
      return;
    }
    this.editprodForm.patchValue({
      bizCompanyEmployees: [...initValue, {
        name: '', title: '', gender: 'M'

      }]
    });
    this.encodedEmployeeBuffer.push(null)
  }



  public setImageOfMoreService(event, i) {
    if (!event.target.files || !event.target.files.length) {
      this.editprodForm.get('moreService').value[i].imageAttachName = '';
    }
    const file = event.target.files[0];
    const imageAttachName = 'imgMoreService' + i;
    console.log('setting ', imageAttachName)
    this.editprodForm.get('moreService').value[i].imageAttachName = imageAttachName;
    console.log('setting ', imageAttachName)
    this.moreServiceImages.set(imageAttachName, file)


    const reader = new FileReader();
    reader.onload = () => {
      this.encodedMorePromoBuffer[i] = reader.result;
    }
    reader.readAsDataURL(file);

  }
  currentProductCategoryAvailableTypes = []
  public typesOfProduct = new Set()
  isProductTime: boolean = false;
  dateFromDb: string;
  checkfromDb: boolean = false;
  basedProduct: string = 'home';
  public userData: User = null;
  public  customBookButton= ''
  public setVerifiedTag(event) {
    const value = event.target.value
    console.log('New value is', value)
    this.verifiedTag = value

  }
  public removeShopTab(i){
    const initValue = this.editprodForm.get('tabsInfo').value ?? []
    initValue.splice(i, 1)
    this.editprodForm.patchValue({
      tabsInfo: initValue
    })
  }


  public addShopTab() {
    const initValue = this.editprodForm.get('tabsInfo').value ?? []
    this.editprodForm.patchValue({
      tabsInfo: [...initValue, {title: '', content:''}]
    })
  }

  public verifiedTag: string = '';


  constructor(
    public modalService: NgbModal,
    private auth: AuthServiceService,
    private local: LocalServiceService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private calendar: NgbCalendar,
    private route: ActivatedRoute,
    public roleService: RoleService,
    public commonService: CommonService,
    private customerService: CustomerService,
    private store: Store<AppState>,
    private gaService: GoogleAnalyticsService,
    private sharedService: SharedService,
    private popup: PopUpService,
    private cdr: ChangeDetectorRef,
    @Inject('WINDOW') private window: any,
  ) {
    if (this.sharedService.isBrowser()) {
      this.shopTemplate = localStorage.getItem('shopTemplate') ? localStorage.getItem('shopTemplate') : 'default';
      this.generateFormValidator();
      this.getShopMember();
      this.getSubRegionList();
      this._getTemplateList();
      this.commonService.categoryList.subscribe((val: any) => {
        this.categoriesList = val.map((e) => {
          return {
            keyName: e.name,
            sub: e.subCategory.map((i) => ({
              keyName: i.categoryName,
              ...i,
            })),
          };
        });
      });
    }
  }

  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    smartSpeed: 4500,
    slideTransition: 'linear',
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
    },
    nav: true,
  };

  customOptions2: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    autoplay: false,
    navSpeed: 700,
    smartSpeed: 4500,
    // autoplaySpeed:4500,
    autoplayHoverPause: true,
    slideTransition: 'linear',
    navText: [
      '<i class="fas fa-chevron-left"></i>',
      '<i class="fas fa-chevron-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 2,
      },
      740: {
        items: 3,
      },
      940: {
        items: 3,
      },
    },
    nav: true,
  };
  authUser: any = {};
  bizProfiles: any = []

  /****************** This block contains code related to main image cropping ********************************/

  public imageToBeCropped: string = ''
  private cropperMovesInXAxis: boolean = false;
  private isDraggingCropper: boolean = false;
  private cropperSquareElement = null;

  private cropperMinX = -1;
  private cropperMinY = -1;
  private cropperMaxX = -1
  private cropperMaxY = -1

  private currentCropperX = 0;
  private currentCropperY = 0;

  private imageWidth = 0;
  private imageHeight = 0;


  private initialX = -1;
  private initialY = -1;



  public cropperDragStart(event) {
    console.log("drag started")
    this.isDraggingCropper = true;
    this.initialX = event.clientX - this.cropperSquareElement.offsetLeft;
    this.initialY = event.clientY - this.cropperSquareElement.offsetTop;
  }


  public cropperDragContinue(event) {
    console.log("drag moving")
    if (this.isDraggingCropper) {
      let newX = event.clientX - this.initialX
      let newY = event.clientY - this.initialY;

      if (this.cropperMovesInXAxis) { //lock check
        if (newX > this.cropperMaxX) {
          newX = this.cropperMaxX
        }
        else if (newX < this.cropperMinX) {
          newX = this.cropperMinX;
        }

        this.cropperSquareElement.style.left = `${newX}px`;
        this.currentCropperX = newX;

      } else if (!this.cropperMovesInXAxis) {
        if (newY > this.cropperMaxY) {
          newY = this.cropperMaxY
        }
        else if (newY < this.cropperMinY) {
          newY = this.cropperMinY;
        }

        this.cropperSquareElement.style.top = `${newY}px`;
        this.currentCropperY = newY;

      }






    }

  }

  public cropperDragEnd() {
    console.log("drag stopped")
    this.isDraggingCropper = false;
  }

  public saveCrop() {
    let offsetRatio;
    if (this.cropperMovesInXAxis) {
      offsetRatio = (this.currentCropperX - this.cropperMinX) / this.imageWidth;
    } else {
      offsetRatio = (this.currentCropperY - this.cropperMinY) / this.imageHeight;
    }

    const payloadToBeSave = {
      isYAxisTheOneThatIsLocked: this.cropperMovesInXAxis,
      offsetRatio,
      imageAspectRatio: this.imageWidth / this.imageHeight
    }
    this.cropModalRef?.close();

    this.editprodForm.patchValue({
      mainImageCropInformation: payloadToBeSave
    })


  }

  private cropModalRef: NgbModalRef | null;
  private totalRotationDegree = 0
  @ViewChild('cropImageModal') cropImageModal: TemplateRef<any>;
  public rotateImage(event, image='main') {
    event.stopPropagation();

    if(image == 'main'){
      this.totalRotationDegree -= 90

      let currentCropInformationToBeSaved = this.editprodForm.get('mainImageCropInformation').value;
      currentCropInformationToBeSaved = {
        ...currentCropInformationToBeSaved,
        rotationInDegrees: this.totalRotationDegree % 360,
      };
      this.editprodForm.patchValue({ mainImageCropInformation: currentCropInformationToBeSaved })

    }else{
      const cropInfoOfOtherImages = this.editprodForm.get('otherImagesCropInfo').value ?? {}

      let currentCropInfoOfSelectedImage = cropInfoOfOtherImages[image] ?? {};
      let totalRotation = currentCropInfoOfSelectedImage?.rotationInDegrees ?? 0;

      totalRotation -= 90;

      currentCropInfoOfSelectedImage = {...currentCropInfoOfSelectedImage, rotationInDegrees: totalRotation};

      cropInfoOfOtherImages[image] = currentCropInfoOfSelectedImage

      this.editprodForm.patchValue({otherImagesCropInfo: cropInfoOfOtherImages})

    }

  }

  public openCropModal(imageToBeCropped: string) {
    this.imageToBeCropped = imageToBeCropped;

    this.cropModalRef =  this.modalService.open(this.cropImageModal, {
     // forceMode: 'modal',
       size: 'md'}) as NgbModalRef // forced so np
     //this.modalService.open(this.cropImageModal, { size: 'md' });

    this.cropModalRef.shown.subscribe(() => {
      const imageToBeCroppedElement = document.getElementById('imageToBeCropped');
      this.cropperSquareElement = document.getElementById('cropper');

      if (!imageToBeCropped || !this.cropperSquareElement) {
        console.error("Error element is missing");
        return;
      }

      this.imageWidth = imageToBeCroppedElement.clientWidth;
      this.imageHeight = imageToBeCroppedElement.clientHeight;



      //if the height is greater the square will fill the image and will only move up or down
      if (this.imageHeight > this.imageWidth) {
        this.cropperMovesInXAxis = false;
      } else {
        this.cropperMovesInXAxis = true;
      }

      const cropperSqaureSize = Math.min(this.imageHeight, this.imageWidth);

      this.cropperMinX = imageToBeCroppedElement.clientLeft;
      this.cropperMaxX = imageToBeCroppedElement.clientLeft + this.imageWidth - cropperSqaureSize;

      this.cropperMinY = imageToBeCroppedElement.clientTop;
      this.cropperMaxY = imageToBeCroppedElement.clientTop + this.imageHeight - cropperSqaureSize;

      console.log(this.cropperMaxX, this.cropperMinX, this.cropperMaxY, this.cropperMinY);



      console.log("setting square size to", cropperSqaureSize)
      this.cropperSquareElement.style.width = cropperSqaureSize + "px";
      this.cropperSquareElement.style.height = cropperSqaureSize + "px";

      console.log('square is set')





    })
  }

  /******************************************************************************************************** */

  ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete()
  }
  ngOnInit(): void {

    if (!this.edit_product_id) {
      this.basedProduct = this.memberShopProductType != 'promote' ? 'business' : 'home';

    }
    this.roleService.rolesSubject.pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.isAdmin = response?.userType?.includes('ADMIN');
      this.cdr.detectChanges();
    })
    this.getSubRegionList()

    const id = this.local.getUser()?.id ? this.local.getUser().id : '';
    this.authUser = this.local.getUser();

    this.adminId = this.route.snapshot.queryParams.adminId ?? id;

    this.shopWebLink = `${this.window?.location?.origin}/#/biz/`;
    !this.enableMemberShop ? this.getAllCategories() : '';

    this.form = this.fb.group({
      published: true,
      editCat: this.fb.array([]),
    });

    this.generateFormValidator();
    this.bannerFormValidator();
    this.get_bottom_banner();

    if (this.authUser) {
      this.getBizProfiles()
      this.getProductsForSlider();
      this.getAllSliderBanners();
      //this.getShopInfo();

      this.store
        .pipe(select(selectUser))
        .pipe(filter((user) => !!user))
        .subscribe((resp: User) => {
          this.userData = resp;
          if (resp?.regionName) {
            this.currentMemberRegion = resp?.regionName;
            this.currentMemberRegionId = resp?.region;
          }
        });

    }
    this.featchMainCate('');
    this.getAllCategoriesList();
  }
  public shopProfileTabs = [
    { title: 'Shop Profile' },
    { title: 'Reviews' },
    { title: 'Social' },
    { title: 'More Badges' },
    { title: 'Employees' }
  ]
  public shoutProfileMenu = 0


  transformArray(arr) {
    const grouped = arr.reduce((acc, item) => {
      const [category, location] = item.name.split('|');
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push({
        id: item.id,
        keyName: location,
        name: category,
        region: location,
      });
      return acc;
    }, {});

    return Object.keys(grouped).map((key) => ({
      keyName: key,
      sub: grouped[key],
    }));
  }


  get editproduct() {
    return this.editprodForm.controls;
  }

  get bannerControl() {
    return this.bannerForm.controls;
  }

  get bottomBannerControl() {
    return this.bottomImagesForm.controls;
  }
  get bottomBannerControlEdit() {
    return this.bottomImagesFormEdit.controls;
  }

  bannerFormValidator() {
    this.bannerForm = this.fb.group({
      banner: ['', [Validators.required]],
    });
  }

  //-----------------------------ADD---------------------------------------

  ingredientsEdit() {
    return this.editprodForm.get('ingredientsEdit') as FormArray ?? new FormArray([]);
  }
  newIngredient(): FormGroup {
    return this.fb.group({
      weight: ['', [Validators.required]],
      price: ['', [Validators.required, Validators.min(0)]],
      nprice: [''],
      costPrice: [''],
    });
  }

  newIngredientEdit(): FormGroup {
    return this.fb.group({
      id: [''],
      weight: ['', [Validators.required]],
      price: ['', [Validators.required]],
      nprice: [''],
      costPrice: [''],
      outOfStockSingle: [''],
      image: ['']
    });
  }


  addIngredientEdit() {

    if (this.ingredientsEdit().length < 10) {
      this.ingredientsEdit().push(this.newIngredientEdit());
    } else {
      console.log({ len: this.ingredientsEdit() })
      this.toastr.error('Only Ten Variations can be added!');
    }
  }

  removeIngredientEdit(i: number) {
    this.ingredientsEdit().removeAt(i);
  }

  //--------------------------EDIT----------------------------------------------

  generateFormValidator() {
    let sellerInfo = '<b> Seller Info </b>\n';
    sellerInfo +=
      'Information is not provided. Please do contact Seller via other methods\n\n';
    sellerInfo += '<b> Delivery </b>\n';
    sellerInfo += 'Delivery options are not specified.\n\n';
    sellerInfo += '<b> Ambassador Program </b>\n';
    sellerInfo += 'Seller is not part of any AP program.\n\n';

    this.editprodForm = this.fb.group({
      name: ['', [Validators.required]],
      descp: ['', [Validators.required]],
      charges: ['', []],
      delivery: ['', []],
      chat_url: [''],
      unit: ['From'],
      product_date: [''],
      dateCheckBox: [false],
      holidays: [''],
      seller_info: [sellerInfo],
      nonMemPrice: [''],
      costPrice: [''],
      qty: [1],
      outOfStockAll: [false],
      googleReviewUrl: [''],
      googleReviewRating: [''],
      googleReviewCount: [''],
      carousellReviewUrl: [''],
      carousellReviewRating: [''],
      carousellReviewCount: [''],
      fbReviewUrl: [''],
      fbReviewRating: [''],
      fbReviewCount: [''],
      websiteUrl: [''],
      fbUrl: [''],
      instagramUrl: [''],
      sellerInfo: [''],
      // seller-info Tab ** new ctrl **
      image1: [''],
      image2: [''],
      image3: [''],
      image4: [''],
      icon1: [''],
      icon2: [''],
      icon3: [''],
      icon4: [''],
      ingredientsEdit: this.memberShopProductType == 'promote' ? this.fb.array([]) : this.fb.array([this.newIngredientEdit()]),
      verified: [[]],
      tabsInfo: [[]],
      faqInfos: [[]],
      more_products: [[]],
      templateName: [''],
      postalCode: [''],
      depositAmt: [0],
      estimateValue: [0],
      warranty: [0],
      referralLink: [false],
      storeLink: [false],
      shoutContact: [''],
      shoutContactRelation: [null],
      shoutWebsite: [null],
      companyName: [null],
      shoutImage: [null],
      shopPageEnabled: [0],
      shoutName: [null],
      shoutLink: [null],
      shoutDescription: [null],
      moreService: [[]],
      bizCompanyEmployees: [[],],
      expiryInString: [this.availableExpiryIntervals[0]],
      shoutInfo: [''],
      promoCode: [''],
      metadata: [null],
      schema: [null],
      mainImageCropInformation: [null],
      otherImagesCropInfo: [{image2: null, image3: null, image4: null}],
      superDealText: [''],
      superDealRating: [0],
      bestPriceText: [''],
      bestPriceRating: [0],
      highQualityText: [''],
      highQualityRating: [0]

    });
  }
  public showExpiry = false;
  public availableExpiryIntervals = ['1 Week', '1 Month', '2 Month', 'Never']
  public expiryStringChanged(event, i) {
    const value = event.target?.value;
    this.editprodForm.get('moreService').value[i].expiryInString = value
  }
  companyNameSearchSuggestions = []

  public getCompanyNameSuggestions(event) {
      const value = event.target.value
      if ( value.length < 6) {
        this.companyNameSearchSuggestions = []
        return;
      }
    
      this.auth.getCompanyNameSuggestions(value).subscribe({
        next: (data: any) => {
          this.companyNameSearchSuggestions = data.data;
          this.cdr.detectChanges()
        }
      })
  }

  removeMoreService(i) {
    const initValue = this.editprodForm.get('moreService').value ?? []
    initValue.splice(i, 1)
    this.editprodForm.patchValue({
      moreService: initValue
    })
    this.encodedMorePromoBuffer.splice(i, 1)
  }
  addMoreService() {
    const initValue = this.editprodForm.get('moreService').value ?? []
    if (initValue.length >= 4) {
      return;
    }
    this.editprodForm.patchValue({
      moreService: [...initValue, {
        serviceComment: '', imageAttachName: '', iconText: '', allowRefer: false, referAmount: null,
        serviceDescription: '', expiryInString: '1 Week', isPercentage: false, useOffText: false
      }]
    });
    this.encodedMorePromoBuffer.push(null)
  }
  public moreServiceIcons = [
    'fa-solid fa-crown',
    'fa fa-thumbs-up',
    'fas fa-gem',
    "fa-solid fa-lightbulb",
    "fa-solid fa-trophy",
    "fa-solid fa-fire",
    "fa-solid fa-medal",
    "fa-solid fa-heart",
    "fa-solid fa-trophy",
    "fas fa-bolt"
  ]

  addFAQ(i) {
    const initValue = this.editprodForm.get('faqInfos').value ?? []
    this.editprodForm.patchValue({
      faqInfos: [...initValue, { question: '', answer: '' }]
    })
  }
  removeFAQ(i) {
    const initValue = this.editprodForm.get('faqInfos').value ?? []
    initValue.splice(i, 1)
    this.editprodForm.patchValue({
      faqInfos: initValue
    })
  }



  removeVerified(i) {
    const initValue = this.editprodForm.get('verified').value ?? []
    initValue.splice(i, 1)
    this.editprodForm.patchValue({
      verified: initValue
    })
  }

  addVerified() {
    const initValue = this.editprodForm.get('verified').value ?? []
    this.editprodForm.patchValue({
      verified: [...initValue, { value: '', isGolden: 0 }]
    })
  }

  getValidity(i) {
    return (<FormArray>this.form.get('editCat')).controls[i].invalid;
  }

  getProductsForSlider() {
    // alert()
    this.auth.get_selected_products(this.adminId).subscribe(
      (response: any) => {
        this.get_selected_products_listing = response.body;
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }

  getProductList(subCatId, tabIndex) {

    const formDataFoodListing = new FormData();
    formDataFoodListing.append('categoryId', this.selectedCatId);
    formDataFoodListing.append('subCategoryId', subCatId);
    formDataFoodListing.append('adminId', this.adminId);
    this.moreProductsSelect = [];
    if (this.enableMemberShop) {
      console.log("FETCH getMemberShopProductList 4")
      this.customerService.getMemberShopProductList({ categoryId: "", subCategoryId: "", limit: 1003 }).subscribe(
        (response: any) => {
          this.food_listing_response = response.body.data;
          this.food_listing_response.map((row: any) => {
            this.moreProductsSelect.push({
              value: row.id.toString(),
              label: row.name,
            });
          });
        }
      );
    } else {
      this.auth.food_listing(formDataFoodListing).subscribe(
        (response: any) => {
          this.food_listing_response = response.body;
          this.food_listing_response.map((row: any) => {
            this.moreProductsSelect.push({
              value: row.id.toString(),
              label: row.name,
            });
          });
        }
      );
    }


  }

  update_show_hide_status() {
    let formData = new FormData();
    formData.append('type', '1');

    this.auth.showHideMemberPrice(formData).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
      },
      (e) => {
        // this.toastr.error(e.error.message);
        this.modalService.dismissAll();
      }
    );
  }

  newTab(modal = null): void {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(
      modal == 'sub' ? this.addSubCategoryModal : this.addCategoryModal,
      { size: 'sm', ariaLabelledBy: 'modal-basic-title' }
    );
  }

  openEditCatModal(modal = null): void {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(this.editCategoryModal, {
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
      windowClass: 'my-edit-cat-modal',
    });

    let formData = new FormData();
    formData.append('type', '0');

    this.auth.showHideMemberPrice(formData).subscribe(
      (response: any) => {
        this.showHideMemberPriceStatus = response.body;
      },
      (e) => {
        //this.toastr.error(e.error.message);
        this.modalService.dismissAll();
      }
    );
  }

  openEditSubCatModal(modal = null): void {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(this.editSubCategoryModal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
      windowClass: 'my-edit-cat-modal',
    });
    // console.log(modal);
  }

  // openChangeProductPosition(modal): void {
  //   this.modalService.dismissAll();
  //   this.modalRef = this.modalService.open(modal, {
  //     size: 'sm',
  //     ariaLabelledBy: 'modal-basic-title',
  //     backdrop: 'static',
  //   });
  // }

  private _resetData() {
    this.submitted = false;
    this.isTabDescriptionActive = 1;
    this.food_image_1_url = '';
    this.food_image_2_url = '';
    this.food_image_3_url = '';
    this.food_image_4_url = '';
    this.errorList = [];
    this.isProductTime = false;
    this.selectHoliday = false;
    this.selectedDates = [];
    this.rotateImgInfo = { image1: 0, image2: 0, image3: 0, image4: 0 };
  }

  public addedToProductPage = null;
  private setSelectedCategory(selectedCategory){
    if(selectedCategory){
       this.selectedCategoryId = selectedCategory?.categorieChildId || selectedCategory?.id;
       this.selectedCatId = this.selectedCategoryId //why 2 ??? TODO REMOVE 1
       this.selectedCategoryNameForDD = selectedCategory?.name || selectedCategory?.categoryName
       this._fetchTypesOf(this.selectedCategoryId);
       console.log({selectedCategory}, this.selectedCategoryNameForDD)
    
    }
  }
  public setSelectedTypes(types){
    if(!types || ! Array.isArray(types)){
      return;
    }
    this.typesOfProduct = new Set(types.map(type => type?.id).filter( tId => tId))
   // console.log('selecting type', types.map(type => type), this.typesOfProduct)
  }
  public newProduct({closeAll=true, addedToProductPage=null, isAd=false, variantCategoryId=null,
    isTypeShopProduct = false,
    selectedCategory = null, selectedTypes = null, memberShopProductType = null} = {}): NgbModalRef {
    this.setSelectedCategory(selectedCategory);
    this.setSelectedTypes(selectedTypes)
    if(memberShopProductType){
      this.memberShopProductType = memberShopProductType
    }
    this.isTypeShopProduct = isTypeShopProduct
    this.variantCategoryId = variantCategoryId
  
    //console.log({arguments})
    if(!this.local.getUser()?.id){
      this.refererId = 2
    }

 
    this.isAd = isAd;
    if (this.enableMemberShop) {
      if(!selectedCategory){
        this.selectedCategoryNameForDD = this.selectedCatId = '';
      }
      if (!this.selectedSubRegionId) {
        this.selectedSubRegionId = this.commonService.getSubregionId(
          this.currentMemberRegion
        );
      }
      this.addedToProductPage = addedToProductPage?.id

      this.subRegionName = this.selectedSubRegionId
        ? this.commonService.getSubregionName(this.selectedSubRegionId)
        : '';


      if (this.memberShopProductType != 'promote') {
        this.subRegionList = this.subRegionList.filter((row) => row.keyName != 'All')
      }
    } else {
      // Validation
      const subCategoryCondition = this.memberShopProductType != 'promote' && !this.roleService?.roles?.userType.includes('ADMIN')
      if (!this.selectedCatId || (!subCategoryCondition && !this.selectedSubRegionId)) {
        let errorMsg = '';
        if(this.selectedCatId){
          errorMsg = 'Please select category.'
        }
        if(!this.selectedSubRegionId){
          errorMsg = 'Please select sub region.'
        }
    
        this.toastr.error(errorMsg);
        this.errorList.push(errorMsg);
        return;
      }
      // Validation
    }

    this.shopForm.disable();
    this.formType = 'Create';

    if (this.authUser?.postalCode) {
      this.maps.postalCode = this.authUser.postalCode;
    }
    if(closeAll){
      this.modalService.dismissAll();
    }

    this.getProductList(this.selectedSubRegionId, this.selectedSubCatIndex)
    this.generateFormValidator();
    // !this.enableMemberShop
    //   ? this.getProductList(this.selectedSubRegionId, this.selectedSubCatIndex)
    //   : '';
    //this.modalService.dismissAll();
    this.editprodForm.reset();
    this.checkArray = [];
    this.editprodForm.get('qty').setValue(1);
    this.percent_value = 0;
    this.percent_type = 0;

    this._resetData();
    this.modalRef = this.modalService.open(this.editProduct, {
      size: 'xl',
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
      windowClass: 'new-product',
     // forceMode: 'modal'

    }) 
    // this.modalRef = this.modalService.open(this.editProduct, {
    //   size: 'xl',
    //   ariaLabelledBy: 'modal-basic-title',
    //   // backdrop: 'static',
    //   keyboard: false,
    //   windowClass: 'new-product',
    // });new
    return this.modalRef
  }

  openAddBannerModal(modal): void {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
      windowClass: 'my-upload-banner-modal',
    });

    this.getAllSliderBanners();
  }

  show_add_icon_modal(content, item: any, index: number) {
    this.addReviewModal = this.modalService.open(content, {
      size: 'sm',
      // backdrop: 'static',
    });
    this.focusIcon = item;
    this.focusIcon.index = index;
  }

  // handleTypeIcon() {
  //   const icon = this.focusIcon;
  //   const value = `${this.food_details.percent_type == 0 ? '$' : ''}${this.food_details.percent_value
  //     }${this.food_details.percent_type == 0 ? '' : '%'}`;

  //   if (icon.index == 1) {
  //     this.focusIcon.text = `<br/><br/><b style="font-family: 'Jost-Bold'"> Save Up Program </b><br/>\n`;
  //     this.focusIcon.text += `Upload receipt upon completion to get an additional <b style="font-family: 'Jost-Bold'"><u>${value}</u></b> OFF your bill. <br />\nContinue supporting your favourite business to SaveUp even More in future!`;
  //   } else if (icon.index == 2) {
  //     this.focusIcon.text = `<br/><br/><b style="font-family: 'Jost-Bold'">Location</b><br/>\n`;
  //     this.focusIcon.text += `Business operates only in the <b style="font-family: 'Jost-Bold'"><u>${icon.value}</u></b> locale.`;
  //   }
  // }

  // saveIcon(isCancel = false) {
  //   const icon = this.focusIcon;
  //   if (isCancel) {
  //     this.focusIcon.value = '';
  //     this.icons[icon.index] = this.focusIcon;
  //     document.getElementById('closeIconModal').click();
  //     return;
  //   }

  //   if (icon.value == '') {
  //     return this.toastr.error('Please Select the Type !');
  //   }

  //   this.icons[icon.index] = this.focusIcon;
  //   document.getElementById('closeIconModal').click();
  // }
  // private processCropInfo(info) {
  //   try {
  //     return JSON.parse(this.food_details?.mainImageCropInformation);

  //   } catch (e) {
  //     return null;
  //   }

  // }
  private _parseJson(str){
    try{
      return JSON.parse(str);
    }catch(e){
      console.error(e)
      return null;
    }
   
  }
  @Output()
  productDataChanged = new EventEmitter();

  ///////////////////////////////////////////////////////////////////////////////////////////////////////
  ///// Promote recommendation to a service
 // public isMapSelectorShowing= true;
  public recommendationImage = ''
  public recommendationImage2 = '';
  public recommendationImage3 = ''
  public promoteRecommendation(recomm) {
    this._resetData();
    this.formType = 'Create';
    this.memberShopProductType = 'promote'
    if (this.ingredientsEdit().length) {
      console.log('removing defualt variation')
      this.ingredientsEdit().clear();
    } //since shoutout no need for variant 

    this.editprodForm.patchValue({
      name: (recomm.nameOfServiceProvider ?? ''),
      shoutName: (recomm.nameOfServiceProvider ?? ''),
      descp: (recomm.uniqueSellingPointOne ?? '') + '\n' + (recomm.uniqueSellingPointTwo ?? '') + '\n' + (recomm.pointOfContact ?? ''
         +  ( recomm.additionalDescr ?? '') 
      ),
      companyName: (recomm.company ?? ''),
      shoutContact: (recomm.phone ?? '')


    })
    if (recomm.imageLocation) {
      this.recommendationImage = recomm.imageLocation
    }
    if(recomm.optionalImageOne){
      this.recommendationImage2 = recomm.optionalImageOne;
    }
    if(recomm.optionalImageTwo){
      this.recommendationImage3 = recomm.optionalImageTwo;
    }
    this.refererId = recomm.memberId;
   // this.isMapSelectorShowing = false;
    if(typeof recomm.latLng	 == 'string'){
      try{
        this.maps.latLong = JSON.parse(recomm.latLng);
      }catch(e){
        console.error(e)
      }

    }
   // this.isMapSelectorShowing = true;
    console.log('map latLong', this.maps.latLong)

   


    this.modalRef = this.modalService.open(this.editProduct, {
      size: 'xl',
      ariaLabelledBy: 'modal-basic-title',
      keyboard: false,
     // forceMode: 'modal'
    })

    // this.modalRef = this.modalService.open(this.editProduct, {
    //   size: 'xl',
    //   ariaLabelledBy: 'modal-basic-title',
    //   // backdrop: 'static',
    //   keyboard: false,
    // });
    this.selectedCategoryNameForDD = recomm.categoryName;
    this.subRegionName = recomm.regionName;
    this.selectedCatId = recomm.categoryId
    this.selectedSubRegionId = recomm.subRegionId

    const recommImageKeys =  ['imageLocation','optionalImageOne', 'optionalImageTwo'];
    let thisImageIndex = 1
    for(const key of recommImageKeys){
      if(recomm[key]){
        const thisKey = `food_image_${thisImageIndex++}_url`
        this[thisKey] = recomm[key]

      }
    }

    //console.log(this.selectedCatId, this.selectedSubRegionId)

  }



  ///////////////////////////////////////////////////////////////////////////////////////////////////////

  editProductModal(food_id): void {
    try {
      this._resetData();

      this.formType = 'Update';
      // this.modalService.dismissAll();
      this.isProductTime = false;
      this.selectHoliday = false;
      this.selectedDates = [];

      //this.shopForm.disable();

      this.edit_product_id = food_id;
      let obsver: Observable<any> = null;
      if (!this.enableMemberShop) {
        let formData = new FormData();
        formData.append('foodId', food_id);
        obsver = this.auth.get_food_details(formData);
      } else {
        obsver = this.auth.getShopProductDetails({ productId: food_id });
      }


      obsver.subscribe(
        (response: any) => {

          this.food_details = response.body;
          this.basedProduct = this.food_details.basedProduct;

          this.unit =
            this.food_details.unit == 'null' ? this.unit : this.food_details.unit;
          this.percent_value = this.food_details.percent_value;
          this.percent_type = this.food_details.percent_type;
          this.indexImageUrl = this.food_details?.indexImage || '';
          this.isTypeShopProduct = this.food_details?.isTypeShop;
          this.editprodForm.patchValue({ tabsInfo: this.food_details.tabsInfo ?? [] });
          this.customBookButton = this.food_details.customBookButton
          console.log("tabsInfo", this.food_details.tabsInfo)
          this.detailsIconConvertedUrl = this.imgUrl + (this.food_details?.detailsIcon ?? '')
          const getImageUrl = (images, accessor) => {
            const image = images.find((o) => o.imageAccessor === accessor);
            return image ? image.image : '';
          };

          if (this.enableMemberShop) {
            this.food_image_1_url = getImageUrl(
              this.food_details.memberShopProductsImages,
              'image1'
            );
            this.food_image_2_url = getImageUrl(
              this.food_details.memberShopProductsImages,
              'image2'
            );
            this.food_image_3_url = getImageUrl(
              this.food_details.memberShopProductsImages,
              'image3'
            );
            this.food_image_4_url = getImageUrl(
              this.food_details.memberShopProductsImages,
              'image4'
            );
          } else {
            this.food_image_1_url = getImageUrl(
              this.food_details.foodImages,
              'image1'
            );
            this.food_image_2_url = getImageUrl(
              this.food_details.foodImages,
              'image2'
            );
            this.food_image_3_url = getImageUrl(
              this.food_details.foodImages,
              'image3'
            );
            this.food_image_4_url = getImageUrl(
              this.food_details.foodImages,
              'image4'
            );

          }
          this.getProductList(this.selectedsubCatId, this.selectedSubCatIndex);

          let foodSpecsArray = [];

          this.foodSpecsLength = this.enableMemberShop
            ? response.body.memberShopProductsVariations.length
            : response.body.foodSpecs.length;

          if (this.food_details.icons != null && this.food_details.icons != '') {
            JSON.parse(this.food_details.icons).map((row: any, index: number) => {
              this.icons[index] = {
                ...this.icons[index],
                ...row,
              };
            });
          } else {
            this.icons.map((row: any) => {
              row.value = '';
            });
          }
          if (this.enableMemberShop) {
            response.body.memberShopProductsVariations.forEach((element) => {
              foodSpecsArray.push({
                id: element.id,
                weight: element.value,
                nprice: element.nKey,
                price: parseFloat(element.key) ? parseFloat(element.key) : 0,
                costPrice: element.costPrice,
                outOfStockSingle: element.outOfStockSingle,
                image: element.image
              });
              if (element.outOfStockSingle == 1) {
                this.checkArray.push(true);
              }
            });
            this.selectedSubRegionId = response.body.subRegionId;
            this.subRegionName = this.commonService.getSubregionName(
              response.body.subRegionId
            );
          } else {
            response.body.foodSpecs.forEach((element) => {
              foodSpecsArray.push({
                id: element.id,
                weight: element.value,
                nprice: element.nKey,
                price: parseFloat(element.key) ? parseFloat(element.key) : 0,
                costPrice: element.costPrice,
                outOfStockSingle: element.outOfStockSingle,
                image: element.image
              });
              if (element.outOfStockSingle == 1) {
                this.checkArray.push(true);
              }
            });
          }

          this.patchBlocks(foodSpecsArray);
          const chatUrl = this.food_details.chat_url;
          const dateCheckBox = this.food_details.dateCheckBox;
          this.checkfromDb = this.food_details.dateCheckBox;
          this.postalCode = this.food_details?.postalCode;
          this.maps.postalCode = this.food_details?.postalCode;

          try {
            this.selectedDates = JSON.parse(this.food_details.holidays) || [];
          } catch (e) {
            this.selectedDates = [];
          }

          if (this.food_details.dateCheckBox || this.food_details.holidays) {
            this.isProductTime =
              this.food_details.dateCheckBox =
              this.selectHoliday =
              true;
          }

          let sellerInfoDefault = '<b> Seller Info </b>\n';
          sellerInfoDefault +=
            'Information is not provided. Please do contact Seller via other methods\n\n';
          sellerInfoDefault += '<b> Delivery </b>\n';
          sellerInfoDefault += 'Delivery options are not specified.\n\n';
          sellerInfoDefault += '<b> Ambassador Program </b>\n';
          sellerInfoDefault += 'Seller is not part of any AP program.\n\n';

          this.shoutImage = this.food_details?.shoutImage ?? ''
          this.editprodForm.patchValue({
            name: this.food_details?.name,
            unit: this.food_details?.unit,
            descp: this.food_details?.description,
            charges: this.food_details?.charges,
            delivery: this.food_details?.delivery,
            chat_url:
              chatUrl != '' && chatUrl != 'null'
                ? this.food_details?.chat_url
                : '',
            dateCheckBox: this?.food_details?.dateCheckBox || 0,
            memPrice: this.food_details?.memberPrice,
            nonMemPrice: this.food_details?.mrp,
            costPrice: this.food_details?.costPrice,
            qty: parseInt(this.food_details?.maxQty),
            outOfStockAll: this.food_details?.outOfStockAll == 1 ? true : false,
            more_products:
              this.food_details?.more_products != null && this.food_details?.more_products != 'undefined'
                ? JSON.parse(this.food_details?.more_products)
                : [],
            postalCode: this.maps.postalCode,
            depositAmt: this.food_details?.depositAmt || 0,
            estimateValue: this.food_details?.estimateValue || 0,
            warranty: this.food_details?.warranty || 0,
            referralLink: this.food_details?.referralLink,
            shoutContact: this.food_details?.shoutContact
              ? this.food_details?.shoutContact
              : '',
            shoutContactRelation: this.food_details?.shoutContactRelation,
            shoutWebsite: this.food_details?.shoutWebsite,
            companyName: this.food_details?.companyName ?? '',
            storeLink: this.food_details?.storeLink,
            image1: this.food_image_1_url,
            image2: this.food_image_2_url,
            image3: this.food_image_3_url,
            image4: this.food_image_4_url,
            verified: this.food_details?.productVerficationsList,
            faqInfos: this.food_details?.faqInfos ? JSON.parse(this.food_details?.faqInfos) : [],
            moreService: this.food_details?.productMoreServices,
            bizCompanyEmployees: this.food_details?.bizCompanyEmployees,
            expiryInString: this.food_details?.expiryInString,
            mainImageCropInformation: this._parseJson(this.food_details?.mainImageCropInformation),
            otherImagesCropInfo: this._parseJson(this.food_details?.otherImagesCropInfo),
            shoutImage: this.shoutImage,
            shoutName: this.food_details?.shoutName,
            shoutLink: this.food_details?.shoutLink,
            shoutDescription: this.food_details?.shoutDescription,
            shoutInfo: this.food_details?.shoutInfo != 'null' ? this.food_details?.shoutInfo : '',
            shopPageEnabled: this.food_details?.shopPageEnabled,

            googleReviewUrl: this.food_details?.seller_info?.googleReviewUrl || '',
            googleReviewRating: this.food_details?.seller_info?.googleReviewRating || '',
            googleReviewCount: this.food_details?.seller_info?.googleReviewCount || '',
            carousellReviewUrl: this.food_details?.seller_info?.carousellReviewUrl || '',
            carousellReviewRating: this.food_details?.seller_info?.carousellReviewRating || '',
            carousellReviewCount: this.food_details?.seller_info?.carousellReviewCount || '',
            fbReviewUrl: this.food_details?.seller_info?.fbReviewUrl || '',
            fbReviewRating: this.food_details?.seller_info?.fbReviewRating || '',
            fbReviewCount: this.food_details?.seller_info?.fbReviewCount || '',
            websiteUrl: this.food_details?.seller_info?.websiteUrl || '',
            fbUrl: this.food_details?.seller_info?.fbUrl || '',
            instagramUrl: this.food_details?.seller_info?.instagramUrl || '',
            //sellerInfo: this.food_details?.seller_info || '',
            promoCode: this.food_details?.promoCode,
            superDealText: this.food_details?.seller_info?.superDealText || '',
            superDealRating: this.food_details?.seller_info?.superDealRating || 0,
            bestPriceText: this.food_details?.seller_info?.bestPriceText || '',
            bestPriceRating: this.food_details?.seller_info?.bestPriceRating || 0,
            highQualityText: this.food_details?.seller_info?.highQualityText || '',
            highQualityRating: this.food_details?.seller_info?.highQualityRating || 0,


            metadata: this.food_details?.metadata ?? '',
            schema: this.food_details?.schema ?? '',
          });
          this.verifiedTag = this.food_details?.verifiedTag ?? '';

          // this.modalRef = this.modalService.open(this.editProduct, {
          //   size: 'xl',
          //   ariaLabelledBy: 'modal-basic-title',
          //   // backdrop: 'static',
          //   keyboard: false,
          // });
          this.modalRef = this.modalService.open(this.editProduct, {
            size: 'xl',
            ariaLabelledBy: 'modal-basic-title',
            keyboard: false,
          //  forceMode: 'modal'
          })

        },
        (e) => {
          this.toastr.error(e.error.message);
          this.modalService.dismissAll();
        }
      );
    } catch (e) {
      console.log("error when edit product", e)
    }
  }

  getBizProfiles() {
    this.customerService.getBizProfiles().subscribe((response) => {
      this.bizProfiles = response.body
    })
  }

  bizProfileChange(event) {
    const biz = this.bizProfiles.filter((row) => row.id == event.target.value)[0]
    const sellerInformation = biz['seller_info']
    console.log({ biz })

    this.editprodForm.patchValue({
      shoutName: biz.shop_name,
      shoutLink: environment.baseUrl + '/biz/shop/' + biz.id,
      shoutDescription: biz.shop_description,
      googleReviewUrl: sellerInformation?.googleReviewUrl,
      googleReviewRating: sellerInformation?.googleReviewRating,
      googleReviewCount: sellerInformation?.googleReviewCount,
      carousellReviewUrl: sellerInformation?.carousellReviewUrl,
      carousellReviewRating: sellerInformation?.carousellReviewRating,
      carousellReviewCount: sellerInformation?.carousellReviewCount,
      fbReviewUrl: sellerInformation?.fbReviewUrl,
      fbReviewRating: sellerInformation?.fbReviewRating,
      fbReviewCount: sellerInformation?.fbReviewCount,
      websiteUrl: sellerInformation?.websiteUrl,
      instagramUrl: sellerInformation?.instagramUrl,
      superDealText: sellerInformation?.superDealText || '',
      superDealRating: sellerInformation?.superDealRating || 0,
      bestPriceText: sellerInformation?.bestPriceText,
      bestPriceRating: sellerInformation?.bestPriceRating,
      highQualityText: sellerInformation?.highQualityText,
      highQualityRating: sellerInformation?.highQualityRating
    });

    this.shoutImage = biz.shop_logo
    this.shoutImageText = biz.shop_logo
  }

  patchBlocks(blocksData) {
    // console.log(blocksData,'-------------------------------blobks data-----------------------------------')
    let items = this.editprodForm.get('ingredientsEdit') as FormArray;
    // console.log(items,'------------------------------pathc block items')

    while (items.length > 0) {
      items.removeAt(0);
    }

    // console.log(items,'------------------------------pathc block items 1')

    blocksData.forEach((element, index) => {
      if (index >= 0) {
        items.push(this.newIngredientEdit());
      }
    });

    if (blocksData.length == items.value.length) {
      // console.log('-------------------------------LENGTH EQUAL------------------------------')
      // console.log("blocksData...", blocksData);
      this.editprodForm.patchValue({
        ingredientsEdit: blocksData,
      });
    }

    // console.log(items,'------------------------------pathc block items 22')
  }

  edit(modal, type) {
    this.newTab(modal);
    if (type == 'cat') {
      let fgArr = (this.categories || []).map((e) => {
        //form control
        return this.getFormGroup(e);
      });

      const rep = this.form.controls.editCat as FormArray; //form array
      rep.controls = [];
      for (let i = 0; i < fgArr.length; i++) {
        //adding values to the form array type
        rep.push(fgArr[i]);
      }
    }
  }

  checkVal() {
    // console.log(this.moreProductsValue);
  }

  validateImage(arrays: any) {
    const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.webp)$/i;
    for (let item of arrays) {
      const file = this.editprodForm.value[item];
      if (file) {
        // console.log(file)
        const check = allowedExtensions.test(file);
        let check2 = true
        if (file?.name) {
          check2 = allowedExtensions.test(file.name);
        }
        if (!check && !check2) {
          return 'Invalid Format, Only Format JPG/JPEG/PNG/WEBP Upload Image';
        }
      }
    }
    return null;
  }

  public async submit(): Promise<void> {
    this.errorList = [];
    // templated creation Event --->s
    if (this.enableTemplateView) {
      this.templateViewEvents.next({
        action: 'save',
        data: {
          category: this.selectedCategoryId,
          templateName: this.editprodForm.get('templateName').value,
          name: this.editprodForm.get('name').value,
          description: this.editprodForm.get('descp').value,
        },
      });
      return;
    } // templated creation Event --->

    this.submitted = true;

    if (
      this.memberShopProductType == 'bless'
      // ||
      // this.memberShopProductType == 'promote'
    ) {
      for (let i of this.editprodForm.controls.ingredientsEdit['controls']) {
        i.controls.price.setValue('0');
        i.controls.costPrice.setValue('0');
        // if (this.memberShopProductType == 'promote') {
        //   i.controls.weight.setValue('0');
        //   i.controls.price.setValue('0');
        // }
      }
    }

    // ****** Validation  ******

    if (this.editprodForm.controls.shoutContact.invalid) {
      let errorMsg = 'Please Check Contact Number!';
      this.toastr.error(errorMsg);
      this.errorList.push(errorMsg);
      return;
    }

    if (this.enableMemberShop && !this.selectedCatId) {
      let errorMsg = 'Please select category.';
      this.toastr.error(errorMsg);
      this.errorList.push(errorMsg);
      return;
    }
    const subCategoryCondition = this.memberShopProductType != 'promote' && !this.roleService?.roles?.userType.includes('ADMIN')
    if (this.enableMemberShop && !this.selectedSubRegionId && !subCategoryCondition) {
      let errorMsg = 'Please select sub-region.';
      this.toastr.error(errorMsg);
      this.errorList.push(errorMsg);
      return;
    }

    // if (this.editprodForm.get("qty").value > 5) {
    //   let errorMsg = "Quantity Cannot be more then 5 !";
    //   this.toastr.error(errorMsg);
    //   this.errorList.push(errorMsg);
    //   return;
    // }


    if (this.editprodForm.invalid) {
      let errorMsg = 'Please Fill All Forms !';
      this.toastr.error(errorMsg);
      for (let i in this.editprodForm.controls) {
        if (this.editprodForm.get(i).invalid) {
          if (i == 'ingredientsEdit') {
            // if(this.memberShopProductType == 'promote' && this.editprodForm.get(i).value.length == 0){
            //   this.editprodForm.patchValue({
            //     ingredientsEdit: [{
            //       value: 0,
            //       nKey: 0
            //     }]
            //   })

            // }else{
            this.errorList.push('Price is required');
            //}

          } else {
            this.errorList.push(i + ' is required');
          }
        }
      }
      return;
    }

    if (!this.editprodForm.value.image1 && !this.recommendationImage && !this.recommendationImage2) {
      let errorMsg = 'Please Add Primary Image (Image Position one)';
      this.toastr.error(errorMsg);
      this.errorList.push(errorMsg);
      return;
    }

    // ****** Validation  ******

    this.editprodForm.value.categoryId = this.selectedCatId;
    this.editprodForm.value.subCategoryId = this.selectedsubCatId;

    let jsonString = this.editprodForm.value.ingredientsEdit ?? [];
    if (jsonString && jsonString.length == 0 && this.memberShopProductType != 'promote') {
      let errorMsg = 'Please add atleast one variation.';
      this.toastr.error(errorMsg);
      this.errorList.push(errorMsg);
      return;
    }

    if (this.memberShopProductType == 'promote' && jsonString?.length && !this.editprodForm.value.unit) {
      let errorMsg = 'Please enter a unit.';
      this.toastr.error(errorMsg);
      this.errorList.push(errorMsg);
      return;

    }

    this.spinner.show();

    if (!this.editprodForm.value.dateCheckBox) {
      this.selectedDates = [];
    }

    let holidaysString = JSON.stringify(this.selectedDates);
    jsonString = jsonString.map((i) => {
      let input = i;
      input.price = input?.price ? input?.price.toString() : '';
      input.nprice = input?.nprice || 0;
      input.costPrice = input?.costPrice || 0;
      return input;
    });
    let jsonStrings = JSON.stringify(jsonString);
    const formData = new FormData();

    formData.append('subRegionId', this.selectedSubRegionId);
    formData.append('categoryId', this.editprodForm.value.categoryId);
    formData.append('subCategoryId', this.editprodForm.value.subCategoryId);
    formData.append('name', this.editprodForm.value.name);
    formData.append('verifiedTag', this.verifiedTag)
    if(this.isTypeShopProduct){
      formData.append('isTypeShopProduct', '1')
    }
    if(this.variantCategoryId){
      formData.append('variantCategoryId', this.variantCategoryId)
    }
    formData.append(
      'mrp',
      this.editprodForm.value.nonMemPrice == ''
        ? 0
        : this.editprodForm.value.nonMemPrice
    );
    formData.append('shopPageEnabled', (this.editprodForm.get('shopPageEnabled').value ? '1' : ''))
    // if(  this.editprodForm.get('image1').value){
    //   formData.append('image1',   this.editprodForm.get('image1').value)
    // }
    let imageIndex = 1;
    for(const thisKey of ['recommendationImage', 'recommendationImage2', 'recommendationImage3'])
    {
      if(this[thisKey]){
        formData.append(`image${imageIndex++}`, this[thisKey])
      }
    }
    // if (this.recommendationImage) {
    //   formData.append('image1', this.recommendationImage)
    // }


    
    // if (this.recommendationImage2) {
    //   formData.append('image2', this.recommendationImage2)
    // }
    
    // if (this.recommendationImage3) {
    //   formData.append('image3', this.recommendationImage3)
    // }
    


    if (this.memberShopProductType && this.memberShopProductType == 'promote') {
      formData.append('memberPrice', '0');
      formData.append('costPrice', '0');
      formData.append(
        'shoutContact',
        this.editprodForm.value.shoutContact || 0
      );
      formData.append(
        'shoutContactRelation',
        this.editprodForm.value.shoutContactRelation
      );
      formData.append(
        'shoutWebsite',
        this.editprodForm.value.shoutWebsite
      );
      formData.append('companyName',
        this.editprodForm.value.companyName
      )
      formData.append(
        'shoutName',
        this.editprodForm.value.shoutName
      );
      formData.append(
        'shoutLink',
        this.editprodForm.value.shoutLink
      );
      formData.append(
        'shoutDescription',
        this.editprodForm.value.shoutDescription
      );
      formData.append(
        'shoutInfo',
        this.editprodForm.value.shoutInfo
      );
      formData.append(
        'shoutImageText',
        this.shoutImageText
      );

    } else {
      formData.append(
        'memberPrice',
        this.editprodForm.value.memPrice == ''
          ? 0
          : this.editprodForm.value.memPrice
      );
      formData.append(
        'costPrice',
        this.editprodForm.value.costPrice == ''
          ? 0
          : this.editprodForm.value.costPrice
      );
    }
    formData.append('customBookButton', this.customBookButton)
    formData.append('shopTabsInfo', JSON.stringify(this.editprodForm.value?.tabsInfo ?? []))
    formData.append('description', this.editprodForm.value.descp);
    formData.append('charges', this.editprodForm.value.charges);
    formData.append('delivery', this.editprodForm.value.delivery);
    formData.append('chat_url', this.editprodForm.value.chat_url);
    formData.append(
      'dateCheckBox',
      this.editprodForm?.value?.dateCheckBox || 0
    );
    formData.append('holidays', holidaysString);
    formData.append('referralLink', this.editprodForm.value.referralLink);
    formData.append('storeLink', this.editprodForm.value.storeLink);

    if (this.memberShopProductType && this.memberShopProductType == 'rental') {
      formData.append('depositAmt', this.editprodForm.value.depositAmt || 0);
      formData.append(
        'estimateValue',
        this.editprodForm.value.estimateValue || 0
      );
      formData.append('warranty', this.editprodForm.value.warranty || 0);
    }

    let sellerInfo: any = {
      googleReviewUrl: this.shopForm.value?.googleReviewUrl || '',
      googleReviewRating: this.shopForm.value?.googleReviewRating || '',
      googleReviewCount: this.shopForm.value?.googleReviewCount || '',
      carousellReviewUrl: this.shopForm.value?.carousellReviewUrl || '',
      carousellReviewRating: this.shopForm.value?.carousellReviewRating || '',
      carousellReviewCount: this.shopForm.value?.carousellReviewCount || '',
      fbReviewUrl: this.shopForm.value?.fbReviewUrl || '',
      fbReviewRating: this.shopForm.value?.fbReviewRating || '',
      fbReviewCount: this.shopForm.value?.fbReviewCount || '',
      websiteUrl: this.shopForm.value?.websiteUrl || '',
      fbUrl: this.shopForm.value?.fbUrl || '',
      instagramUrl: this.shopForm.value?.instagramUrl || '',
      //sellerInfo: this.shopForm.value?.sellerInfo || '',
      superDealText: this.shopForm.value?.superDealText || '',
      superDealRating: this.shopForm.value?.superDealRating || 0,
      bestPriceText: this.shopForm.value?.bestPriceText,
      bestPriceRating: this.shopForm.value?.bestPriceRating,
      highQualityText: this.shopForm.value?.highQualityText,
      highQualityRating: this.shopForm.value?.highQualityRating
    };
    if (this.memberShopProductType == 'promote') {
      sellerInfo = {
        googleReviewUrl: this.editprodForm.value?.googleReviewUrl || '',
        googleReviewRating: this.editprodForm.value?.googleReviewRating || '',
        googleReviewCount: this.editprodForm.value?.googleReviewCount || '',
        carousellReviewUrl: this.editprodForm.value?.carousellReviewUrl || '',
        carousellReviewRating: this.editprodForm.value?.carousellReviewRating || '',
        carousellReviewCount: this.editprodForm.value?.carousellReviewCount || '',
        fbReviewUrl: this.editprodForm.value?.fbReviewUrl || '',
        fbReviewRating: this.editprodForm.value?.fbReviewRating || '',
        fbReviewCount: this.editprodForm.value?.fbReviewCount || '',
        websiteUrl: this.editprodForm.value?.websiteUrl || '',
        fbUrl: this.editprodForm.value?.fbUrl || '',
        instagramUrl: this.editprodForm.value?.instagramUrl || '',
        // sellerInfo: this.editprodForm.value?.sellerInfo || '',
        superDealText: this.editprodForm.value?.superDealText || '',
        superDealRating: this.editprodForm.value?.superDealRating || 0,
        bestPriceText: this.editprodForm.value?.bestPriceText,
        bestPriceRating: this.editprodForm.value?.bestPriceRating,
        highQualityText: this.editprodForm.value?.highQualityText,
        highQualityRating: this.editprodForm.value?.highQualityRating
      };

    }

    formData.append('seller_info', JSON.stringify(sellerInfo));
    formData.append('verified', JSON.stringify((this.editprodForm.value?.verified ?? [])));
    formData.append('faqInfos', JSON.stringify(this.editprodForm.value?.faqInfos ?? []))
    formData.append(
      'maxQty',
      this.editprodForm.value.qty == ''  ||   this.editprodForm.value.qty  == 'null' ? 0 : this.editprodForm.value.qty
    );
    formData.append('jsonString', jsonStrings);

    const imagesForm = ['image1', 'image2', 'image3', 'image4', 'shoutImage'];

    const checkImage = this.validateImage([...imagesForm]);

    if (checkImage != null) {
      this.toastr.error(checkImage);
      return;
    }

    for (let imageForm of imagesForm) {
      formData.append(imageForm, this.editprodForm.get(imageForm).value);
    }

    formData.append('unit', this.editprodForm.value.unit);
    formData.append('adminId', this.adminId);
    formData.append(
      'isRecommendedProduct',
      this.isRecommendedProduct ? '1' : '0'
    );
    formData.append(
      'outOfStockAll',
      (this.editprodForm.value.outOfStockAll == true ? 1 : 0).toString()
    );
    formData.append(
      'more_products',
      JSON.stringify(this.editprodForm.value.more_products)
    );
    formData.append('postalCode', this.maps.postalCode);

    let latLong : string = "{}"
    this.maps.postalCode != '' ? JSON.stringify(this.maps.latLong) : '{}'
    
    console.log('latLong info', typeof latLong, {latLong})
    console.log('current postalCode is', this.maps.postalCode)
    if(!latLong ||  
      (typeof latLong == "object" && Object.keys(latLong).length < 2) || 
      (typeof latLong == "string" && latLong.trim()?.length <= 2)
    ){
      if(!(this.maps.postalCode || this.local.getUser()?.postalCode)){
        this.local.alertInfo({
          title: "Missing PostalCode",
          message: "Please enter a postal code either in this product or in your account"
        });
        return;
      }
      console.log("fetching latLong from postalCode")
      latLong =  JSON.stringify(await this.local.getLatLongByPostalCode(this.maps.postalCode || this.local.getUser()?.postalCode))
    }
    formData.append('latLong', latLong);
    const icons = this.icons;
    formData.append(
      'icons',
      JSON.stringify(
        icons.map((row: any) => {
          return {
            value: row.value,
            text: row.text,
          };
        })
      )
    );

    let type = 'edit';
    if (this.formType == 'Update') {
      this.enableMemberShop
        ? formData.append('productId', this.edit_product_id)
        : formData.append('foodId', this.edit_product_id);
    } else {
      type = 'add';
    }

    if (this.enableMemberShop && this.memberShopProductType) {
      if (this.memberShopProductType == 'promote') {
        formData.append('type', 'promote');
        formData.append('basedProduct', this.basedProduct);
      } else {
        formData.append('type', this.memberShopProductType);
      }
    }

    const attachMoreServiceImages = (v => {
      // console.log({v}); 
      if (!v.imageAttachName && this.formType != 'Update') {
        this.toastr.error("Some Promo are missing images!");
        throw new Error('Some Promo are missing images')

      }
      // if (!v.iconText) {
      //   this.toastr.error("Icon Missing!");
      //   throw new Error('Some Promo are missing icons!')

      // }

      if (!v.serviceComment) {
        this.toastr.error("Some Promo are missing texts!");
        throw new Error('Some Promo are missing texts!')

      }

      if (this.moreServiceImages.has(v.imageAttachName)) {
        formData.append(v.imageAttachName, this.moreServiceImages.get(v.imageAttachName));
      } else if (this.formType != 'Update') {
        this.toastr.error("Some Promo are missing images!");
        throw new Error('Some Promo are missing images')

      }

      return v
    })


    const attachVariantImage = (v => {


      if (v.imageAttachName && this.variansImages.has(v.imageAttachName)) {
        formData.append(v.imageAttachName, this.variansImages.get(v.imageAttachName));
      }

      return v
    })

    const attachEmployeeImages = (v => {
      // console.log({v}); 
      if (!v.imageAttachName && this.formType != 'Update' && !v.gender) {
        this.toastr.error("Some employees are missing images!");
        throw new Error('Some employees are missing images')

      }
      // if (!v.iconText) {
      //   this.toastr.error("Icon Missing!"yees);
      //   throw new Error('Some Promo are missing icons!')

      // }

      if (!v.name) {
        this.toastr.error("Some employees are missing name!");
        throw new Error('Some employees are missing name!')

      }
      if (!v.title) {
        this.toastr.error("Some employees are missing title!");
        throw new Error('Some employees are missing title!')

      }

      if (this.employeeImages.has(v.imageAttachName)) {
        formData.append(v.imageAttachName, this.employeeImages.get(v.imageAttachName));
      } else if (this.formType != 'Update' && !v.gender) {
        this.toastr.error("Some employees are missing images!");
        throw new Error('Some employees are missing images')

      }

      return v
    })
    if (this.memberShopProductType == 'promote') {
      formData.append('promoCode', this.editprodForm.value.promoCode)
    }

    formData.append('imgRotateInfo', JSON.stringify(this.rotateImgInfo));
    formData.append('indexImage', this.indexImageUrl);
    if (this.memberShopProductType == 'promote' && this.editprodForm?.value?.moreService) {
      formData.append('otherServices', JSON.stringify(Array.from(
        this.editprodForm.value.moreService?.map(attachMoreServiceImages)))
      );
      formData.append('employees', JSON.stringify(this.editprodForm.value.bizCompanyEmployees?.map(attachEmployeeImages)))
    }
    this.editprodForm.get('ingredientsEdit').value.forEach(attachVariantImage);
    // if(this.memberShopProductType == 'promote'){
    //   console.log('appending expiry', this.editprodForm.get('expiryInString').value)
    //   formData.append('expiryInString', this.editprodForm.get('expiryInString').value)
    // }else{
    //   console.log('not appending expirt', this.memberShopProductType)
    // }
  //  console.log('cropInfo', this.editprodForm.value?.otherImagesCropInfo)
    formData.append('mainImageCropInformation', JSON.stringify(this.editprodForm.value?.mainImageCropInformation))
    formData.append('otherImagesCropInfo', JSON.stringify(this.editprodForm.value?.otherImagesCropInfo))
   
    if(this.isAd){
      formData.append('isAd', '1')
    }

    formData.append('metadata', this.editprodForm.value.metadata);
    if (this.editprodForm.value.schema) {
      try {
        JSON.parse(this.editprodForm.value.schema)
        formData.append('schema', this.editprodForm.value.schema)
      } catch (e) {
        this.toastr.error("Invalid Schema Json Format")
        return;
      }
    }
    if (this.refererId) {
      formData.append('refererId', this.refererId)
    }
    if( this.addedToProductPage){
      formData.append('addedToProductPage', this.addedToProductPage  )
    }
    if(this.refererId == 2 && this.commonService.clientIp){
      formData.append("ipAddress", this.commonService.clientIp)
    }

    if(this.isTypeShopProduct){
      formData.append('detailsIcon', this.detailsIcon ?? this.detailsIconConvertedUrl)
    }
 

    this.spinner.show();
    this.enableLoader = true;
    (this.enableMemberShop
      ? this.auth[`${type}ShopProduct`](formData)
      : this.auth[`${type}_food`](formData)
    ).subscribe(
      (response: any) => {

        let modiifedProductId = this.edit_product_id || response.body.id;

        for(const type of this.currentProductCategoryAvailableTypes){
          if(this.typesOfProduct.has(type.id)){
            this.auth.addTypeToProduct(modiifedProductId, type.id).subscribe()
          }else{
            this.auth.removeTypeFromProduct(modiifedProductId, type.id).subscribe()
          }
        }

        this.toastr.success(response.message);
        //this.modalService.dismissAll();
        //this.activeModal.close()
        this.modalRef.close();
        this.productDataChanged.emit(true)
        this.selectedDates = [];
        this.editprodForm.reset();
        this.checkArray = [];
        this.spinner.hide();
        if (this.enableMemberShop) {
          this.shopUpdate.next('productUpdate');
          // Common Place to update all state on add/update
          this.store.dispatch(loadIndividualProducts({ categoryId: '', subRegionId: this.currentMemberRegionId, search: '' }));

          this.store.dispatch(loadFilteredCommunityProducts({
            categoryId: '',
            subRegionId: '',
            basedProduct: "home",
          }));

          if (this.formType == 'Update') {
            this.sharedService.refreshProductId.next({productId: this.edit_product_id, action: 'edited'}); //refresh product only and don't scroll

          } else {
            this.store.dispatch(loadAllCommunityProducts({})); //refresh homepage to show new product

          }


          // Common Place to update all state on add/update
        } else {
          this.fetchAllProductList(this.selectedCatId, this.selectedsubCatId);
        }
        this.enableLoader = false;
        this.gaService.logEvent('add_product', {
          userId: this.adminId,
          productId: this.editprodForm.value.name,
          timestamp: new Date().toISOString(),
        });
      },
      ({ error }) => {
        this.spinner.hide();
        this.enableLoader = false;
        this.toastr.error('Unable to add product, please try again:' + error.message);
      }
    );
  }

  onShoutImageSelected(files, modal, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.shoutImage = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.editprodForm.get('shoutImage').setValue(<File>files[0]);
  }

  onImageSelected1(files, modal, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_1_url = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.editprodForm.get('image1').setValue(<File>files[0]);
  }

  onImageSelected2(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_2_url = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.editprodForm.get('image2').setValue(<File>files[0]);
  }

  onImageSelected3(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0]?.type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_3_url = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.editprodForm.get('image3').setValue(<File>files[0]);
  }

  onImageSelected4(files, modal, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.food_image_4_url = event.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.editprodForm.get('image4').setValue(<File>files[0]);
  }

  onBannerSelected(files, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.banner_image_url = event.target.result;
        this.banner_image_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.bannerPath = files;
    this.selectedBanner = <File>files[0];
    this.submitted = false;
  }

  onBottomBannerSelected(files, event) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      if (event.target.files[0].size > 2097152) {
        this.toastr.error('Max File size must be Less than 2MB!');
        return;
      }
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.bottom_banner_image_url = event.target.result;
        this.bottom_banner_image_url_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.bannerPathBottom = files;
    this.selectedBannerBottom = <File>files[0];
    // console.log(this.selectedBanner,'--------------------asd')
  }

  addCategory() {
    if (!this.categoryName || this.categoryName.trim() == '') {
      this.toastr.error('Please add category name');
      return;
    }

    const formData = new FormData();
    formData.append('name', this.categoryName);

    (this.enableMemberShop
      ? this.auth.addMemberProductCategory(formData)
      : this.auth.addCategory(formData)
    ).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.modalService.dismissAll();
        if (this.enableMemberShop) {
          this.shopUpdate.next('categoryUpdated');
        } else {
          this.getAllCategories();
        }
      },
      (e) => {
        //this.toastr.error(e.error.message);
        this.modalService.dismissAll();
      }
    );
  }

  addSubCat() {
    if (!this.subcategoryName || this.subcategoryName.trim() == '') {
      this.toastr.error('Please add sub category name');
      return;
    }

    const formData = new FormData();
    formData.append('categoryId', this.selectedCatId);
    formData.append('name', this.subcategoryName);

    (this.enableMemberShop
      ? this.auth.addMemberProductSubCategory(formData)
      : this.auth.addSubCategory(formData)
    ).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.modalService.dismissAll();
        this.subcategoryName = '';
        if (this.enableMemberShop) {
          this.shopUpdate.next('subCategoryUpdated');
        } else {
          this.getAllSubCategories(this.selectedsubCatId);
        }
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }
  getAllCategories() {
    this.auth.getFoodCategories(this.adminId).subscribe(
      (response: any) => {
        this.categories = response.body;
      },
      (e) => { }
    );
  }
  getAllSubCategories(cate) {
    this.loadingCate = true;
    const formData = new FormData();

    formData.append('categoryId', cate);

    this.auth.getFoodSubCategories(formData).subscribe(
      (response: any) => {
        this.subcategories = response.body;
        this.subcategories.unshift({
          id: '',
          name: 'ALL',
          title: 'ALL',
        });
        this.loadingCate = false;
      },
      (e) => { }
    );
  }
  // my code
  isSelectCarsouel(id) {
    return this.get_selected_products_listing?.some((e) => e.id === id);
  }
  J(o) {
    return JSON.stringify(o)
  }
  public productAllProductListFiltered: Array<any> = [];
  public filterProduct(event: any) {
    // console.log(event.target.value.toLowerCase());
    this.fetchAllProductList(
      this.selectedCatId,
      this.selectedsubCatId,
      1,
      event.target.value.toLowerCase()
    );
  }
  public productAllProductList: Array<any> = [];
  totalPages: any;
  currentPage: any;
  loadingCate = false;
  loadingProduct = true;
  public fetchAllProductList(cate, subCate, page = 1, search = '') {
    if (page === 1) {
      this.loadingProduct = true;
    }
    var params: any = {
      categoryId: cate,
      subCategoryId: subCate,
      limit: 12,
      page: page,
      search: search,
    };
    if (cate == '' && subCate == '') {
      params.adminId = this.adminId;
    }
    this.auth.marketplace_food_listing(params).subscribe((response: any) => {
      this.totalPages = response.body.totalPages;
      this.currentPage = response.body.currentPage;
      if (page > 1) {
        this.productAllProductListFiltered.push(...response.body.data);
        this.readmore = false;
      } else {
        this.productAllProductListFiltered = response.body.data;
      }
      // console.log(this.productAllProductListFiltered.length);
      this.loadingProduct = false;
    });
    // this.loading = false;
  }
  readmore = false;
  readMore() {
    this.readmore = true;
    this.fetchAllProductList(
      this.selectedCatId,
      this.selectedsubCatId,
      this.currentPage + 1
    );
  }
  featchMainCate(cate) {
    this.selectedsubCatId = '';
    if (this.selectedCatId == cate) {
      this.selectedCatId = '';
      this.fetchAllProductList('', '');
      return;
    }
    this.selectedCatId = cate;
    this.fetchAllProductList(cate, '');
    this.getAllSubCategories(cate);
  }
  featchSubCate(cate, subCate) {
    this.selectedsubCatId = subCate;
    this.fetchAllProductList(cate, subCate);
  }
  //end my code

  editCategory() {
    // console.log(this.categories,"========");return;
    const formData = new FormData();

    formData.append('jsonString', JSON.stringify(this.categories));
    // console.log(JSON.stringify(this.categories),'---------------formData')
    // return

    (this.enableMemberShop
      ? this.auth.updateCategory(formData)
      : this.auth.editFoodCategories(formData)
    ).subscribe(
      (response: any) => {
        // this.toastr.success(response.message);
        this.toastr.success('Category Edited Successfully');
        this.modalService.dismissAll();
        this.enableMemberShop ? this.shopUpdate.next('categoryUpdated') : '';
      },
      (e) => {
        //this.toastr.error(e.error.message);
        this.modalService.dismissAll();
      }
    );

    this.modalService.dismissAll();

    // console.log("==========>",data);
  }

  editSubCategory() {
    const formData = new FormData();

    formData.append('jsonString', JSON.stringify(this.subcategories));

    // console.log(JSON.stringify(this.subcategories),'---------------------------subcategories bhalla')

    (this.enableMemberShop
      ? this.auth.updateMemberProductSubCategory(formData)
      : this.auth.editFoodSubCategories(formData)
    ).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.modalService.dismissAll();
        // this.prodForm.reset();
        // this.getProductList(this.selectedsubCatId)
        // this.getAllCategories();
      },
      (e) => {
        //this.toastr.error(e.error.message);
        this.modalService.dismissAll();
      }
    );
  }

  editProductPosition() {
    // console.log(this.food_listing_response,'----------------------------- food listing response')
    // return

    const formData = new FormData();
    let jsonString = this.food_listing_response;

    formData.append('jsonString', JSON.stringify(jsonString));

    this.auth.change_food_order(formData).subscribe(
      (response: any) => {
        // console.log(response,'----------------------response')
        this.modalService.dismissAll();
      },
      (e) => {
        //this.toastr.error(e.error.message);
        this.modalService.dismissAll();
      }
    );
  }

  getFormGroup(obj) {
    let formObj = {};
    let formFields = Object.keys(obj);
    let formValues = Object.values(obj);
    for (let i = 0; i < formFields.length; i++) {
      formObj[formFields[i]] = new FormControl(formValues[i]);
      // console.log(formObj, "==========");
    }
    return new FormGroup(formObj);
  }

  drop(event: CdkDragDrop<{ title: string; poster: string }[]>) {
    // console.log(event)
    moveItemInArray(this.categories, event.previousIndex, event.currentIndex);

    // console.log(event, "================")
  }

  drop2(event: CdkDragDrop<{ title: string; poster: string }[]>) {
    moveItemInArray(
      this.subcategories,
      event.previousIndex,
      event.currentIndex
    );

    // console.log(event, "================")
  }

  drop3(event: CdkDragDrop<{ title: string; poster: string }[]>) {
    moveItemInArray(
      this.food_listing_response,
      event.previousIndex,
      event.currentIndex
    );

    // console.log(event, "================")
  }

  delete_food(food_id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You wany to delete this product!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        let formData = new FormData();
        this.enableMemberShop
          ? formData.append('productId', food_id)
          : formData.append('foodId', food_id);

        (this.enableMemberShop
          ? this.auth.deleteShopProduct(formData)
          : this.auth.delete_food(formData)
        ).subscribe(
          (response: any) => {
            this.modalService.dismissAll();
            Swal.fire('Deleted!', response.message, 'success');
            if (this.isSingleProduct) {
              this.sharedService.triggerSingleProductService({});
            } else
              if (this.enableMemberShop) {
                this.shopUpdate.next('productUpdate');
                // Update Product List in store
                this.sharedService.refreshProductId.next({action: 'deleted', productId: food_id})
                //this.store.dispatch(loadIndividualProducts({ categoryId: '', subRegionId: this.currentMemberRegionId, search: '' }));
                // Update Product List in store
              }
          },
          (e) => {
            //this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  get_food_details(food_id) {
    alert(food_id);
  }

  select_product_for_slider(food_id) {
    // alert(food_id)
    const formData = new FormData();
    formData.append('foodId', food_id);
    formData.append('adminId', this.adminId);

    this.auth.select_produts_for_slider(formData).subscribe(
      (response: any) => {
        // console.log(response,'-------------------------response')
        this.getProductsForSlider();
        this.toastr.success(response.message);
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }

  delete_food_category(id) {
    // console.log(id,'-----------------------------------------food category id')
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this category!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append('categoryId', id);

        (this.enableMemberShop
          ? this.auth.deleteShopProductCategory(formData)
          : this.auth.delete_food_category(formData)
        ).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            if (this.enableMemberShop) {
              this.shopUpdate.next('categoryUpdated');
            } else {
              this.getAllCategories();
              this.getAllSubCategories(this.selectedsubCatId);
            }
          },
          (e) => {
            //this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  delete_food_subategory(id) {
    // console.log(id,'-----------------------------------------food subcategory id')
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this sub-category!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append('subCategoryId', id);
        (this.enableMemberShop
          ? this.auth.deleteShopProductSubCategory(formData)
          : this.auth.delete_food_subcategory(formData)
        ).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            if (this.enableMemberShop) {
              this.shopUpdate.next('subCategoryUpdated');
            } else {
              this.getAllSubCategories(this.selectedsubCatId);
            }
          },
          (e) => {
            //this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  getAllSliderBanners() {
    this.auth.get_all_product_banner(this.adminId).subscribe(
      (response: any) => {
        this.get_all_product_banner_response = response.body;
        this.get_all_product_banner_length = response.body.length;
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }

  delete_product_banner(id) {
    // console.log(id,'-----------------------------------------food subcategory id')
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this banner!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append('productBannerId', id);

        this.auth.delete_product_banner(formData).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            this.getAllSliderBanners();
          },
          (e) => {
            //this.toastr.error(e.error.message);
          }
        );
      }
    });
  }
  uploadProgress: number = 0;
  addBanner() {
    this.submitted = true;
    if (this.bannerForm.invalid) {
      return;
    }
    this.uploadProgress = 0;
    this.spinner.show();
    const formData = new FormData();
    formData.append('image', this.selectedBanner);
    formData.append('adminId', this.adminId);

    this.auth
      .add_product_banner(formData, {
        reportProgress: true,
        observe: 'events',
      })
      .subscribe(
        (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            // Update progress percentage
            this.uploadProgress = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event.type === HttpEventType.Response) {
            this.toastr.success(event.message);
            this.getAllSliderBanners();
            this.banner_image_url_show = 0;
            (this.banner_image_url = ''), this.bannerForm.reset();
            this.spinner.hide();
            this.submitted = false;
            this.uploadProgress = 0;
          }
        },
        (e) => {
          this.toastr.error(e.error.message);
          this.submitted = false;
          this.uploadProgress = 0;
        }
      );
  }

  checkAllCheckboxes(event) {
    if (event.target.checked == true) {
      $('.check_box_all').each(function () {
        $(this).prop('checked', true);
      });

      let items = this.editprodForm.get('ingredientsEdit') as FormArray;

      // let items = this.editprodForm.get('ingredientsEdit');
      // console.log(items.controls,'-----------------controls')

      // console.log(this.editprodForm.get('ingredientsEdit').controls)

      items.controls.map((control) => {
        let newForm = control as FormGroup;
        // control.setValue(true);
        // console.log(control,'-----------------------map control')
        newForm.controls.outOfStockSingle.setValue(true);
        // console.log(newForm.controls.outOfStockSingle.setValue(true),'----------------------------map controls')
      });
    } else {
      $('.check_box_all').each(function () {
        $(this).prop('checked', false);
      });

      let items = this.editprodForm.get('ingredientsEdit') as FormArray;

      items.controls.map((control) => {
        let newForm = control as FormGroup;
        // control.setValue(true);
        // console.log(control,'-----------------------map control')
        newForm.controls.outOfStockSingle.setValue(false);
        // console.log(newForm.controls.outOfStockSingle.setValue(true),'----------------------------map controls')
      });
    }
  }

  onQuantityChange(event) {
    this.editprodForm.get('qty').setValue(event.target.value);
  }

  hide_unhide_cat(id) {
    let formData = new FormData();
    formData.append('categoryId', id);

    this.auth.hide_unhide_cat(formData).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllCategories();
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }

  // searchKey(data: string) {
  //   this.searchText = data;
  //   this.search();
  // }

  // search() {
  //   this.filteredProducts =
  //     this.searchText === ''
  //       ? this.food_listing_response
  //       : this.food_listing_response.filter((element) => {
  //         // return element.name.toLowerCase() == this.searchText.toLowerCase();
  //         return element.name
  //           .toLowerCase()
  //           .includes(this.searchText.toLowerCase());
  //       });
  // }

  openAddBottomImagesModal(modal: any) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
    });

    this.ckEditorText = '';
    this.bottomImagesForm = this.fb.group({
      banner: ['', [Validators.required]],
      title: ['', [Validators.required]],
      // url: ["", [Validators.required]],
      author: ['', [Validators.required]],
    });
  }

  addBottomBanner() {
    // alert()
    this.submitted = true;

    if (this.bottomImagesForm.invalid) {
      return;
    }

    this.spinner.show();

    let formData = new FormData();
    formData.append('title', this.bottomImagesForm.value.title);
    formData.append('text', this.ckEditorText);
    // formData.append('url', this.bottomImagesForm.value.url);
    formData.append('author', this.bottomImagesForm.value.author);
    formData.append('image', this.selectedBannerBottom);
    formData.append('adminId', this.adminId);

    this.auth.add_bottom_banner(formData).subscribe(
      (response: any) => {
        // console.log(response,'--------------------------------------')
        this.spinner.hide();
        this.modalService.dismissAll();
        this.get_bottom_banner();
        this.bottom_banner_image_url_show = 0;
        this.toastr.success(response.message);
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }

  get_bottom_banner() {
    if (this.adminId) {
      this.auth.get_bottom_banner({
        adminId: this.adminId
      }).subscribe((response: any) => {
        this.get_bottom_banner_response = response.body.data;
      });
    }
  }

  openEditBottomImagesModal(modal: any, bottom_banner_id) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
    });

    this.bottomImagesFormEdit = this.fb.group({
      banner: [''],
      title: ['', [Validators.required]],
      author: ['', [Validators.required]],
      // text: ["", [Validators.required]],
      // url: ["", [Validators.required]]
    });

    this.edit_bottom_banner_id = bottom_banner_id;

    let formData = new FormData();
    formData.append('bottomBannerId', bottom_banner_id);

    this.auth.get_one_bottom_banner(formData).subscribe(
      (response: any) => {
        this.get_one_bottom_banner_response = response.body;
        this.bottom_banner_image = response.body.image;
        this.ckEditorText = response.body.text;

        this.bottomImagesFormEdit = this.fb.group({
          banner: [''],
          title: [
            this.get_one_bottom_banner_response.title,
            [Validators.required],
          ],
          author: [
            this.get_one_bottom_banner_response.author,
            [Validators.required],
          ],
          // url: [this.get_one_bottom_banner_response.url, [Validators.required]]
        });
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }
  onEditorChange(event) {
    this.ckEditorText = event.editor.getData();
  }

  editBottomBanner() {
    this.submitted = true;

    if (this.bottomImagesFormEdit.invalid || this.ckEditorText == '') {
      return;
    }

    this.spinner.show();

    let formData = new FormData();
    formData.append('text', this.ckEditorText);
    formData.append('title', this.bottomImagesFormEdit.value.title);
    // formData.append('url', this.bottomImagesFormEdit.value.url);
    formData.append('author', this.bottomImagesFormEdit.value.author);
    formData.append('bottomBannerId', this.edit_bottom_banner_id);
    formData.append('image', this.selectedBannerBottom);

    this.auth.edit_bottom_banner(formData).subscribe(
      (response: any) => {
        // console.log(response,'--------------------------------------')
        this.spinner.hide();
        this.modalService.dismissAll();
        this.get_bottom_banner();
        this.bottom_banner_image_url_show = 0;
        this.toastr.success(response.message);
      },
      (e) => {
        //this.toastr.error(e.error.message);
      }
    );
  }

  // mouse_enter_bottom_image(id) {
  //   // this.bottom_edit_img_hide_show = !this.bottom_edit_img_hide_show;
  //   this.bottom_edit_img_hide_show = id;
  // }

  delete_bottom_banner(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You wany to delete this image!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        let formData = new FormData();
        formData.append('bottomBannerId', id);

        this.auth.delete_bottom_banner(formData).subscribe(
          (response: any) => {
            Swal.fire('Deleted!', response.message, 'success');

            this.get_bottom_banner();
          },
          (e) => {
            //this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  onLogoSelected(files, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.logo_image_url = event.target.result;
        this.logo_image_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.logoPath = files;
    this.selectedLogo = <File>files[0];
  }

  onBannerPhotoSelected(files: FileList, event: Event): void {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    const file = files[0];

    // Check file size (1 MB = 1,048,576 bytes)
    const maxSizeInBytes = 1048576; // 1 MB in bytes
    if (file.size > maxSizeInBytes) {
      console.error('File size exceeds 1 MB');
      this.toastr.error('File size exceeds 1 MB.');

      return;
    }
    if (!mimeType.startsWith('image/')) {
      // Handle error: Only images are supported.
      return;
    }

    const reader = new FileReader();
    reader.onload = (loadEvent: ProgressEvent<FileReader>) => {
      this.shop_Banner_image_url = loadEvent.target?.result as string;
      this.shop_Banner_image_show = true;
    };
    reader.readAsDataURL(files[0]);

    this.Shop_Banner_Path = files;
    this.selectedShopBanner = files[0];
  }

  onQRSelected(files, event: any) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.qr_image_url = event.target.result;
        this.qr_image_show = 1;
      };
      reader.readAsDataURL(event.target.files[0]);
    }

    this.qrPath = files;
    this.selectedQr = <File>files[0];
  }

  show_add_review_modal(content) {
    this.addReviewModal = this.modalService.open(content, {
      size: 'sm',
      // backdrop: 'static',
    });
  }

  openSelectImageDialog(selector) {
    document.querySelector(selector).click();
  }
  checkRating(event) {
    // console.log("event ====>", event)
    if (event?.target?.valueAsNumber > 5) {
      this.productReview.rating = 5;
    }

    if (event?.target?.valueAsNumber < 0) {
      this.productReview.rating = 0;
    }
  }

  saveSeletedImage(event) {
    let file = event.target.files[0];
    this.productReview.image = file;
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imgBase64 = fileReader.result;
    };
    fileReader.readAsDataURL(file);
  }

  saveProductReview() {
    let formData = new FormData();
    for (let key in this.productReview) {
      if (this.productReview.hasOwnProperty(key)) {
        formData.append(key, this.productReview[key]);
      }
    }
    formData.append('foodId', this.edit_product_id);
    this.auth.add_product_review(formData).subscribe(
      (response: any) => {
        this.productReview = {
          userName: '',
          comment: '',
          rating: 0,
        };
        this.imgBase64 = '';
        this.toastr.success(response.message);
        try {
          // Close the review modal
          this.addReviewModal.close();
        } catch (error) {
          // console.log('error closing modal', error);
        }
      },
      (e) => {
        if (e.status == 400) {
          //this.toastr.error(e.error.message);
        }
      }
    );
  }

  updateFoodPercent(value, type) {
    if (value < 0) {
      this.toastr.warning('Less than zero not allowed');
    }

    if (type == 1) {
      const regex = /^[0-9]+(\.[0-9]+)?$/;
      const regexTest = regex.test(value);

      if (regexTest == false) {
        return this.toastr.warning('Enter valid number');
      }
    }

    if (value == true) value = 1;
    if (value == false) value = 0;

    let formData = new FormData();
    formData.append('food_id', this.edit_product_id);
    formData.append('value', value);
    formData.append('type', type);

    this.auth.updateFoodPercent(formData).subscribe(
      (response: any) => {
        if (type == 2) {
          this.toastr.success(response.message);
        }
      },
      (e) => {
        if (e.status == 400) {
          //this.toastr.error(e.error.message);
        }
      }
    );
  }

  onClickVoucher() {
    this.modalService.dismissAll();
    this.router.navigateByUrl(`/admin/voucher`);
  }

  validateNumberInput(event: KeyboardEvent) {
    const charCode = event.charCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  validateNumberPaste(event: ClipboardEvent){
   

    const target = event.target as any;
    const newVal = (event.clipboardData)?.getData('text').replaceAll(' ', '');
    for(let i =0;i < newVal.length; i++){
      const charCode = newVal.charCodeAt(i)
      if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return;
      }
    }
    
   // target.value = newVal;
   

  }

  openShopInfoModalById(shopId: any) {
    this.shopId = shopId;
    this.customerService.getMemberShopsProfileById({ id: shopId }).subscribe(
      (response: any) => {
        this.shopName = response?.body?.shop_name;
        this.postalCode = response?.body?.postalCode;
        this.shopTemplate = localStorage.getItem('shopTemplate')
          ? localStorage.getItem('shopTemplate')
          : 'default';
        this.shop_logo = response?.body?.shop_logo;
        this.shop_qr_image = response?.body?.shop_qr_image;
        this.qr_text = response?.body?.qr_text;
        this.website = response?.body?.website;
        this.address = response?.body?.address;
        this.telegram = response?.body?.telegram;
        if (this.shopName == 'null') {
          this.shopName = '';
        }
        this.store_link = response?.body?.store_link;
        this.QrCodeValue = this.store_link;
      },
      (e) => {
        if (e.status == 400 && !this.enableMemberShop) {
          //this.toastr.error(e.error.message);
        }
        if (
          (e.error.status == 401 || e.status == 401) &&
          !this.enableMemberShop
        ) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );

    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(this.shop_info_modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
      windowClass: 'my-shop-info',
    });
  }

  isProductTimeToggle(event: any): void {
    this.isProductTime = (event.target as HTMLInputElement).checked;
    if (this.isProductTime) {
      this.isProductTime = true;
      //  this.selectHoliday = true
    } else {
      this.selectHoliday = false;
      this.isProductTime = false;
      this.selectedDates = [];

      (document.getElementById('date') as HTMLFormElement).disabled = true;
      (document.getElementById('date') as HTMLInputElement).value = '';
    }
  }

  formatDate(isoDate: string): string {
    if (!isoDate) return '';
    const date = new Date(isoDate);
    const offsetMinutes = date.getTimezoneOffset();
    date.setMinutes(date.getMinutes() - offsetMinutes); // Adjust to local time

    const yyyy = date.getFullYear();
    const MM = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');

    return `${yyyy}-${MM}-${dd}T${hh}:${mm}`;
  }

  showFormattedDateTime() {
    const dateString = `${this.model.year}-${this.formatNumber(
      this.model.month
    )}-${this.formatNumber(this.model.day)}`;
    const timeString = `${this.formatNumber(
      this.time.hour
    )}:${this.formatNumber(this.time.minute)}`;
    this.formattedDateTime = `${dateString}T${timeString}`;
  }

  private formatNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  holidayToggle() {
    if (this.selectHoliday == true) {
      this.selectHoliday = false;
    } else {
      this.selectHoliday = true;
    }
  }

  onDateSelect(date: NgbDateStruct) {
    const selectedDate = new NgbDate(date.year, date.month, date.day);

    if (!this.isSelected(selectedDate)) {
      this.selectedDates.push(selectedDate);
    } else {
      this.selectedDates = this.selectedDates.filter(
        (d) => !this.dateEquals(d, selectedDate)
      );
    }

    // console.log('selectedDates------->', this.selectedDates);
  }

  // Check if the date is already selected
  isSelected(date: NgbDateStruct): boolean {
    return this.selectedDates
      ? this.selectedDates.some((d) => this.dateEquals(d, date))
      : false;
  }

  // Compare two dates for equality
  dateEquals(date1: NgbDateStruct, date2: NgbDateStruct): boolean {
    return (
      date1.year === date2.year &&
      date1.month === date2.month &&
      date1.day === date2.day
    );
  }

  /* ----------------------------------------------------------------------------------------------------- */
  /*  @ Shop **
  /* ----------------------------------------------------------------------------------------------------- */

  // **** Declaration ****
  public shopForm: FormGroup = this.fb.group({
    googleReviewUrl: [''],
    googleReviewRating: [''],
    googleReviewCount: [''],
    carousellReviewUrl: [''],
    carousellReviewRating: [''],
    carousellReviewCount: [''],
    fbReviewUrl: [''],
    fbReviewRating: [''],
    fbReviewCount: [''],
    websiteUrl: [''],
    fbUrl: [''],
    instagramUrl: [''],
    sellerInfo: [''],
    superDealText: [''],
    superDealRating: [''],
    bestPriceText: [''],
    bestPriceRating: [0],
    highQualityText: [''],
    highQualityRating: [0]
  });
  public selShopMenu: string = 'profile';
  public selMenu: string = 'seller-info';
  // **** Declaration ****

  public selectShopMenu(menu: string): void {
    this.selShopMenu = menu;
  }

  public selectMenu(menu: string): void {
    this.selMenu = menu;
  }


  shopCategories = []
  public getAllCategoriesList() {
    this.store.pipe(select(selectAllBizCategory)).subscribe((response: any) => {
      this.shopCategories = structuredClone(response || []);
     // console.log("categoriest are ", this.shopCategories)

      this.shopCategories.map((c) => {
        c["slug"] = c.name.toLowerCase().replace(/ /g, "-");
      });



    });
  }

  public save_shop_profile(): void {
    // if (this.w_phone_number && this.w_phone_number.length !== 8) {
    //   this.toastr.error('Phone number must be 8 digits.');
    //   return;
    // }

    let formData = new FormData();
    formData.append('shop_name', this.shopName);
    formData.append('buyerContact', this.buyerContact ? '1' : '0');
    formData.append('postalCode', this.postalCode);
    formData.append('shop_logo', this.selectedLogo);
    formData.append('shop_banner', this.selectedShopBanner);
    formData.append('shop_qr_image', this.selectedQr);
    formData.append('qr_text', this.qr_text);
    formData.append('website', this.website);
    formData.append('telegram', this.telegram);
    formData.append('address', this.address);
    formData.append('store_link', this.store_link);
    formData.append('w_phone_number', '+65' + this.w_phone_number);
    formData.append('shop_description', this.shop_description);
    formData.append('adminId', this.adminId);
    formData.append('shop_template', this.shopTemplate);
    formData.append('bizCategory', this.bizCategory);
    let sellerInfo: any = {
      googleReviewUrl: this.shopForm.value?.googleReviewUrl || '',
      googleReviewRating: this.shopForm.value?.googleReviewRating || '',
      googleReviewCount: this.shopForm.value?.googleReviewCount || '',
      carousellReviewUrl: this.shopForm.value?.carousellReviewUrl || '',
      carousellReviewRating: this.shopForm.value?.carousellReviewRating || '',
      carousellReviewCount: this.shopForm.value?.carousellReviewCount || '',
      fbReviewUrl: this.shopForm.value?.fbReviewUrl || '',
      fbReviewRating: this.shopForm.value?.fbReviewRating || '',
      fbReviewCount: this.shopForm.value?.fbReviewCount || '',
      websiteUrl: this.shopForm.value?.websiteUrl || '',
      fbUrl: this.shopForm.value?.fbUrl || '',
      instagramUrl: this.shopForm.value?.instagramUrl || '',
      sellerInfo: this.shopForm.value?.sellerInfo || '',
      superDealText: this.shopForm.value?.superDealText || '',
      superDealRating: this.shopForm.value?.superDealRating || 0,
      bestPriceText: this.shopForm.value?.bestPriceText,
      bestPriceRating: this.shopForm.value?.bestPriceRating,
      highQualityText: this.shopForm.value?.highQualityText,
      highQualityRating: this.shopForm.value?.highQualityRating,
    };
    formData.append('seller_info', JSON.stringify(sellerInfo));

    if (this.enableMemberShopAdmin) {
      formData.append('memberId', this.shopId);
    }

    (this.enableMemberShop
      ? this.auth.saveMemberShopsProfile(formData)
      : this.auth.save_shop_profile(formData)
    ).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.modalService.dismissAll();
        this.shopUpdate.next('save_shop_profile');
      },
      (e) => {
        if (e.status == 400) {
          //this.toastr.error(e.error.message);
        }

        if (e.error.status == 401 || e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );
    localStorage.setItem('shopTemplate', this.shopTemplate);
  }

  public open_shop_info_modal(): void {
    this.shopForm.enable();
    (this.enableMemberShop
      ? this.customerService.getMemberShopsProfile()
      : this.auth.get_shop_profile_data(this.adminId)
    ).subscribe(
      (response: any) => {
        this.shopName = response?.body?.shop_name;
        this.buyerContact = response?.body?.buyerContact;
        this.postalCode = response?.body?.postalCode;
        this.shop_logo = response?.body?.shop_logo;
        this.shop_banner = response?.body?.shop_banner;
        this.shop_qr_image = response?.body?.shop_qr_image;
        this.qr_text = response?.body?.qr_text;
        this.website = response?.body?.website;
        this.address = response?.body?.address;
        this.telegram = response?.body?.telegram;
        this.shopId = response?.body?.shop_id;
        if (this.shopName == 'null') {
          this.shopName = '';
        }
        this.store_link = response?.body?.store_link;
        this.QrCodeValue = this.store_link;
        if (this.enableMemberShop) {
          this.w_phone_number = response?.body?.whatsApp_number
            ? response?.body?.whatsApp_number.split('+65')[1]
            : '';
        } else {
          this.w_phone_number = response?.body?.w_phone_number
            ? response?.body?.w_phone_number.split('+65')[1]
            : '';
        }

        this.shop_description = response?.body?.shop_description;
        let sellerInfo = null;
        try {
          sellerInfo = JSON.parse(response?.body?.seller_info);
        } catch (e) { }
        this.shopForm.patchValue({
          googleReviewUrl: sellerInfo?.googleReviewUrl || '',
          googleReviewRating: sellerInfo?.googleReviewRating || '',
          googleReviewCount: sellerInfo?.googleReviewCount || '',
          carousellReviewUrl: sellerInfo?.carousellReviewUrl || '',
          carousellReviewRating: sellerInfo?.carousellReviewRating || '',
          carousellReviewCount: sellerInfo?.carousellReviewCount || '',
          fbReviewUrl: sellerInfo?.fbReviewUrl || '',
          fbReviewRating: sellerInfo?.fbReviewRating || '',
          fbReviewCount: sellerInfo?.fbReviewCount || '',
          websiteUrl: sellerInfo?.websiteUrl || '',
          fbUrl: sellerInfo?.fbUrl || '',
          instagramUrl: sellerInfo?.instagramUrl || '',
          sellerInfo: sellerInfo?.sellerInfo || '',
          superDealText: sellerInfo?.superDealText || '',
          superDealRating: sellerInfo?.superDealRating || 0,

          bestPriceText: sellerInfo?.bestPriceText,
          bestPriceRating: sellerInfo?.bestPriceRating,
          highQualityText: sellerInfo?.highQualityText,
          highQualityRating: sellerInfo?.highQualityRating
        });

        this.shopTemplate = localStorage.getItem('shopTemplate');
        if (!this.shopTemplate) {
          localStorage.setItem('shopTemplate', 'default');
          this.shopTemplate = 'default';
        }
        this.getRegionNameByPostal();
      },
      (e) => {
        if (e.status == 400 && !this.enableMemberShop) {
          //this.toastr.error(e.error.message);
        }
        if (
          (e.error.status == 401 || e.status == 401) &&
          !this.enableMemberShop
        ) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );

    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(this.shop_info_modal, {
      ariaLabelledBy: 'modal-basic-title',
      // backdrop: 'static',
      windowClass: 'my-shop-info',
    });
  }

  public getShopInfo(): void {
    if (this.local.getUser()) {
      (this.enableMemberShop
        ? this.customerService.getMemberShopsProfile()
        : this.auth.get_shop_profile_data(this.adminId)
      ).subscribe((response: any) => {
        this.shopId = response?.body?.shop_id;
        this.shopName = response?.body?.shop_name;
        this.shop_logo = response?.body?.shop_logo;
        this.shop_description = response?.body?.shop_description;
        this.bizCategory = response?.body.bizCategory

        const data = response.body;
        let sellerInfo = null;
        try {
          sellerInfo = JSON.parse(response?.body?.seller_info);
        } catch (e) { }

        this.maps.postalCode = data?.postalCode;
        this.shopForm.patchValue({
          googleReviewUrl: sellerInfo?.googleReviewUrl || '',
          googleReviewRating: sellerInfo?.googleReviewRating || '',
          googleReviewCount: sellerInfo?.googleReviewCount || '',
          carousellReviewUrl: sellerInfo?.carousellReviewUrl || '',
          carousellReviewRating: sellerInfo?.carousellReviewRating || '',
          carousellReviewCount: sellerInfo?.carousellReviewCount || '',
          fbReviewUrl: sellerInfo?.fbReviewUrl || '',
          fbReviewRating: sellerInfo?.fbReviewRating || '',
          fbReviewCount: sellerInfo?.fbReviewCount || '',
          websiteUrl: sellerInfo?.websiteUrl || '',
          fbUrl: sellerInfo?.fbUrl || '',
          instagramUrl: sellerInfo?.instagramUrl || '',
          sellerInfo: sellerInfo?.sellerInfo || '',
          superDealText: sellerInfo?.superDealText || '',
          superDealRating: sellerInfo?.superDealRating || 0,

          bestPriceText: sellerInfo?.bestPriceText,
          bestPriceRating: sellerInfo?.bestPriceRating,
          highQualityText: sellerInfo?.highQualityText,
          highQualityRating: sellerInfo?.highQualityRating
        });
      });
    }
  }

  dropdown = [
    {
      name: 'Option 1',
      sub: [
        {
          name: 'Option 1 name 1',
        },
      ],
    },
    {
      name: 'Option 2',
      sub: [
        {
          name: 'Option 2 name 1',
        },
        {
          name: 'Option 2 name 2',
        },
        {
          name: 'Option 2 name 3',
        },
        {
          name: 'Option 2 name 4',
        },
        {
          name: 'Option 2 name 5',
        },
      ],
    },
    {
      name: 'Option 3',
      sub: [
        {
          name: 'Option 3 name 1',
        },
      ],
    },
  ];
  onItemSelected(e) {
    // console.log(e, 'milt');
  }
  public memberTemplateList: Array<any> = [];
  public selectedTemplateList: Array<any> = [];
  public _getTemplateList(): void {
    this.auth.getAllMemberTemplate().subscribe((resp: ApiResponse) => {
      this.memberTemplateList = resp.body;
    });
  }

  public onTemplateChange(selectedTemplateId: MemberTemplate) {
    let selectedTemplate: MemberTemplate = this.memberTemplateList.find(
      (i) => i.id == selectedTemplateId
    );
    this.editprodForm.get('templateName').setValue(selectedTemplate.name);
    this.editprodForm.get('name').setValue(selectedTemplate.name);
    this.editprodForm.get('descp').setValue(selectedTemplate.description);
  }

  public subRegionList: Array<any> = [];
  public regionList = REGION_CATEGORY_IMAGE_LIST;
  public selectedCategoryNameForDD = '';
  public selectedRegionForDD = '';
  public subRegionName = '';
  public addedSubCategoryList: Array<any> = [];
  // why null
  // public selectedCategoryId = null;
  public selectedCategoryId = '';
  public currentMemberRegion: any = '';
  public currentMemberRegionId: any = '';
  public categoriesList: Array<any> = [];

  public onCategoryClick(e, selected: string) {
    e.stopPropagation();
    this.selectedCategoryNameForDD =
      this.selectedCategoryNameForDD == selected ? '' : selected;
  }

  // public onRegionClick(selected: string) {
  //   // e.stopPropagation();

  // }

  public onSubRegionClick(selected: any) {
    //this.selectedRegionForDD = this.selectedRegionForDD == selected ? "" : selected;
    this.subRegionName = selected.name;
    // this.selectedsubCatId = this._getSelectedSubCategoryId();
    this.selectedSubRegionId = selected.subRegionId;
  }

  public changeRegionByMaps(selected: any) {
    if (this.memberShopProductType == 'promote') {
      this.onSubRegionClick(selected)
    }
  }

  // private _getSelectedSubCategoryId(): any {
  //   let id =
  //     this.addedSubCategoryList.filter(
  //       (i: any) => i.name == this.selectedSubCategoryName
  //     )[0]?.id || 0;
  //   if (this.selectedSubCategoryName && id == 0) {
  //     this._addSubCategory(this.selectedCategoryId);
  //   }
  //   return id;
  // }

  // private _addSubCategory(selectedCategoryId) {
  //   if (selectedCategoryId || this.selectedCatId) {
  //     this.auth
  //       .addMemberProductSubCategory({
  //         categoryId: selectedCategoryId || this.selectedCatId,
  //         name: this.selectedSubCategoryName,
  //       })
  //       .subscribe((resp: ApiResponse) => {
  //         this.addedSubCategoryList = resp.body;
  //         let selectedSubCategoryId = this._getSelectedSubCategoryId();
  //         this.selectedCatId = selectedCategoryId;
  //         this.selectedsubCatId = selectedSubCategoryId;
  //       });
  //   }
  // }

  // private _getSubCategoryList(selectedSubCategoryName = '') {
  //   this.selectedCatId = this.selectedCategoryId;
  //   this.auth
  //     .getAllMemberShopSubCategory({
  //       categoryId: this.selectedCategoryId,
  //     })
  //     .subscribe((response: any) => {
  //       this.addedSubCategoryList = response.body;
  //       this.selectedSubCategoryName = this.currentMemberRegion || '';
  //       // why this give me error when use read more
  //       // this.selectedsubCatId = this._getSelectedSubCategoryId();
  //     });
  // }

  public toggleType(type){
    if(this.typesOfProduct.has(type.id)){
      this.typesOfProduct.delete(type.id)
    }else{
      this.typesOfProduct.add(type.id)

    }
     console.log('typesOfProduct', this.typesOfProduct)

  }
  private _fetchTypesOf(catId){
    if(!catId){
      return
    }
    this.auth.getTypesOfCategory(catId)
    .subscribe({
      next: (data: any)=>{
         this.currentProductCategoryAvailableTypes = data.data
         this.auth.getTypesOfProduct(this.edit_product_id)
        .subscribe({
          next: (data: any)=>{
            this.typesOfProduct = new Set(data.data.map(t => t.typeId))
            console.log('typesOfProduct', this.typesOfProduct)
          }
        })
      }
    });
    
  }
  public onCategoryChange(catId: any, catName: any): void {
    this.selectedCatId = catId;
    this.selectedCategoryId = catId;
    this.selectedCategoryNameForDD = catName;
    this._fetchTypesOf(catId)
   
    this.selectedTemplateList = this.memberTemplateList
      .filter((i: any) => i.category == catId)
      .map((j) => {
        return { ...j, keyName: j.templateName };
      });
  }

  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : name;
  }

  public getSubRegionList() {
    this.subRegionList = this.commonService.regionList.map((i) => {
      return {
        keyName: i.name,
        sub: i.subRegions.map((i: any) => {
          return { ...i, keyName: i.name };
        }),
      };
    });
    //  this.commonService.regionList.subscribe((resp:any)=>{
    //   this.subRegionList = resp.map((i)=>{
    //     return { keyName:i.name,sub:i.subRegions.map((i:any)=>{
    //       return{...i,keyName:i.name}
    //     })}
    //   });
    // });
  }

  public deleteImg(type: string) {
    if (type == 'image1') {
      this.food_image_1_url = '';
      this.editprodForm.get('image1').setValue('');
    } else if (type == 'image2') {
      this.food_image_2_url = '';
      this.editprodForm.get('image2').setValue('');
    } else if (type == 'image3') {
      this.food_image_3_url = '';
      this.editprodForm.get('image3').setValue('');
    } else if (type == 'image4') {
      this.food_image_4_url = '';
      this.editprodForm.get('image4').setValue('');
    } else if (type == 'shoutImage') {
      this.shoutImage = '';
      this.editprodForm.get('shoutImage').setValue('');
    }
  }

  public memberList: Array<any> = [];
  public imageBase64: string | ArrayBuffer;
  public selectedMember: any = null;
  public shopMember: FormGroup = new FormGroup({
    title: new FormControl('', [Validators.required]),
    description: new FormControl(''),
    image: new FormControl(null),
  });

  public addMember(selected, modal) {
    this.imageBase64 = null;
    if (selected) {
      this.selectedMember = selected;
      this.shopMember.patchValue({
        title: selected?.title,
        description: selected?.description,
        image: selected?.image,
      });
    } else {
      this.shopMember.reset();
      // this.imageBase64 = null;
      this.selectedMember = null;
    }

    if (!selected) {
      this.modalRef = this.modalService.open(modal, {
        // backdrop: 'static',
        windowClass: 'my-shop-info-member',
      });
    }
  }

  public saveProductCharSelectedImage(event) {
    this.selectedMember ? (this.selectedMember.image = null) : '';
    let file = event.target.files[0];
    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.imageBase64 = fileReader.result;
      this.shopMember.get('image').setValue(file);
    };
    fileReader.readAsDataURL(file);
  }

  public saveShopMember() {
    if (this.memberList.length >= 3 && !this.selectedMember?.id) {
      this.toastr.error('Can Only add 3 Members');
      return;
    }

    if (this.shopMember.valid) {
      let formData = new FormData();
      typeof this.shopMember.get('image').value == 'string'
        ? ''
        : formData.append('image', this.shopMember.get('image').value);

      formData.append('title', this.shopMember.get('title').value);
      formData.append('description', this.shopMember.get('description').value);
      formData.append('user_id', this.local.getUser().id);

      if (this.selectedMember) {
        formData.append('id', this.selectedMember?.id);
      }
      this.uploadProgress = 0;
      this.auth
        .addShopMembers(formData, {
          reportProgress: true,
          observe: 'events',
        })
        .subscribe(
          (resp: any) => {
            if (resp.type === HttpEventType.UploadProgress) {
              // Update progress percentage
              this.uploadProgress = Math.round(
                (100 * resp.loaded) / resp.total
              );
            } else if (resp.type === HttpEventType.Response) {
              this.toastr.success(resp.body.message);
              this.modalRef ? this.modalRef.close() : '';
              this.getShopMember();
              this.selectedMember = null;
              this.uploadProgress = 0;
            }
          },
          ({ error }: any) => {
            this.toastr.error(error.message);
            this.uploadProgress = 0;
          }
        );
    } else {
      this.toastr.error('Form is Invalid fill ALL ');
    }
  }

  public getShopMember() {
    if (this.local.getUser()?.id) {
      this.auth
        .getShopMembers(this.local.getUser().id)
        .subscribe((resp: ApiResponse) => {
          this.memberList = resp.body;
        });
    }
  }

  public addShopMember() {
    this.shopMember.reset();
    this.selectedMember = null;
  }

  public deleteShopMember(id) {
    this.auth.deleteShopMembers(id).subscribe((resp: ApiResponse) => {
      this.toastr.success(resp.message);
      this.getShopMember();
      this.addShopMember();
      this.imageBase64 = null;
    });
  }

  public preventInvalidInput(event: KeyboardEvent) {
    if (
      ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(event.key) ||
      (event.key === '.' && !event.target['value'].includes('.')) // Allow single decimal point
    ) {
      return;
    }

    // Prevent any non-numeric characters
    if (isNaN(Number(event.key))) {
      event.preventDefault();
    }
  }

  public openShopPage() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do u wish to log out and open in new tab!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Open!',
    }).then((result) => {
      if (result.isConfirmed) {
        this.local.logout();
        this.window?.open(this.shopWebLink + this.shopName, '_blank');
        this.window?.location.reload();
      }
    });
  }

  referFriendLink() {
    this.auth
      .userReferralAdd({
        userId: 0,
        referralCode: null,
        shopName: this.shopName,
        shopId: this.shopId,
      })
      .subscribe(
        (response: any) => {
          const referralLink = `${environment.baseUrl}#/${response.body.referralCode}`;
          const textArea = document.createElement('textarea');
          textArea.value = referralLink;
          document.body.appendChild(textArea);
          textArea.select();
          this.store_link = referralLink;
          try {
            document.execCommand('copy');
            if (navigator.userAgent.match(/ipad|iphone/i)) {
              copy(referralLink);
            }
            this.toastr.success('Copied Referral Link to clipboard');
          } catch (err) {
            this.toastr.error('Failed to copy referral link');
          }
          document.body.removeChild(textArea);
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }

  public uploadCatImage(event, id) {
    let file = event.target.files[0];
    this.addImageToCat(id, file);
  }

  public addImageToCat(id, image) {
    let formData = new FormData();
    formData.append('categoryId', id);
    formData.append('image', image);

    this.auth.add_image_cat(formData).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllCategories();
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }

  public getRegionNameByPostal() {
    this.postalCodeRegionName = this.commonService.getSubRegionBaseOnPostalCode(this.postalCode)?.name || '';
  }

  public rotateImgInfo = { image1: 0, image2: 0, image3: 0, image4: 0 };
  public rotateImg(ImgElemnt: HTMLElement, name: string) {

    const currentRotation = ImgElemnt.style.transform.match(/rotate\((\d+)deg\)/);
    const currentAngle = currentRotation ? parseInt(currentRotation[1], 10) : 0;
    const newAngle = (currentAngle + 90) % 360;
    ImgElemnt.style.transform = `rotate(${newAngle}deg)`;
    this.rotateImgInfo[name] = newAngle;

  }
}
